import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../../app/helpers';
import { ConfirmationPopupComponent } from '../../../shared/components/confirmation-popup/confirmation-popup.component';
import { environment } from "../../../../environments/environment";
import { appService } from '../../../../app/_services/app.service';
import { NavService } from '../../../_services/NavService.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../../../app/shared/services/mobile-detection.service';
import { ITableModel } from '../../../../app/shared/components/table/model/tableModel';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
import { CommonService } from '../../../shared/services/commen/commen.services';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-sales-invoice-form',
  templateUrl: './sales-invoice-form.component.html',
  styleUrls: ['./sales-invoice-form.component.scss']
})
// Added by priya - 17/03/2025
export class SalesInvoiceFormComponent implements OnInit {
  static that: SalesInvoiceFormComponent;
  selectedLang: any;
  data: any = {};
  CompanyId: any;
  TenantId: any;
  isInternational: any;
  SelectedCompanyGSTCode: any;
  userId: any;
  hostUrl: any = environment.apiUrl;
  isMobileView: boolean = false;
  isFormSubmit: boolean = false;
  CustomerDetail: any = {};

  headBranchInvoiceNumbringFlag: any;
  SalseUploadChargesOnOffFlag: any = false;
  SalesFlag: any;
  AdditionalMasterFlag: boolean = false;

  saveDisable: boolean = false;
  authorizeDisable: boolean = false;
  postDisable: boolean = false;

  isFormPendingInvoicePage: any = false;
  GeneratedInvoice: any = [];
  GeneratedInvoiceList: any = [];
  fotData: any = {};

  dataToSave: any = {};
  selectedId: any;
  InvoiceNo: any;
  StatusName: any;
  newDropdownVisible: boolean = false;
  // invoiceData: any = {};
  IsWithoutLR: number = 0
  showPayment: boolean = false;
  showJournalEntry: boolean = false;
  showAudit: boolean = false;
  showMailHistory: boolean = false;
  ReceiptSummaryData: any = {};
  JVSummaryData: any = [];
  AuditData: any = {};
  mailHistoryList: any = {};
  dropdownActionVisible: boolean = false;
  dropdownPrintVisible: boolean = false;
  inv_pending_objData: any = {};
  inv_pending_arrayData: any = [];
  CopyAndCreateNewDisable: boolean = false; // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  InvoiceTypeList: any = []; // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  @ViewChild('ExpenseNBills') ExpenseNBills: TemplateRef<any>; // Added by priya - 09/05/2026 - cn(PRIYA-MAR26-001)
  Expensebytrip: any = []; // Added by priya - 09/05/2026 - cn(PRIYA-MAY26-002)
  BillByTrip: any = []; // Added by priya - 09/05/2026 - cn(PRIYA-MAY26-002)

  // added by yash 06-05-2026
  isNotesPanelOpen: boolean = false;
  notesTransactionType: string = 'Sales Invoice';
  notesTransactionId: any = null;
  // end by yash 06-05-2026

  BillToParty: any = {
    lable: "",
    formControlName: 'BillToParty',
    dataField: 'BillToParty',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Bill To Party",
  };
  InvoiceDate: any = {
    lable: 'Invoice Date',
    formControlName: 'InvoiceDate',
    dataField: 'InvoiceDate',
    isRequired: true,
    type: "text",
    placeholder: 'Select Invoice Date'
  };
  CreditDays: any = {
    lable: 'Credit Days',
    formControlName: 'CreditDays',
    dataField: 'CreditDays',
    isRequired: true,
    placeholder: "Enter Credit Days",
    isReadOnly: false,
  };
  InvoiceDueDate: any = {
    lable: 'Invoice Due Date',
    formControlName: 'InvoiceDueDate',
    dataField: 'InvoiceDueDate',
    isRequired: false,
    type: "text",
    placeholder: 'Select Invoice Due Date'
  };
  RefNo: any = {
    lable: 'Reference No',
    formControlName: 'RefNo',
    dataField: 'RefNo',
    placeholder: "Enter Reference No",
    isReadOnly: false,
  };
  TransType: any = {
    lable: 'Transaction Type',
    formControlName: 'IsWithoutLR',
    dataField: 'IsWithoutLR',
    isValueBind: true,
    placeholder: "Select Transaction Type",
  };
  BoschUsername: any = {
    lable: "Bosch Username/Contact Person:",
    formControlName: 'BoschUsername',
    dataField: 'BoschUsername',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Bosch Username/Contact Person:",
  };
  DivisionName: any = {
    lable: "Customer Business Division Name",
    formControlName: 'DivisionName',
    dataField: 'DivisionName',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Business Division Name",
  };
  WarehouseName: any = {
    lable: "Customer Warehouse/Plant Name",
    formControlName: 'WarehouseName',
    dataField: 'WarehouseName',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Customer Warehouse/Plant Name",
  };
  EntityName: any = {
    lable: "Customer Legal Entity Name",
    formControlName: 'EntityName',
    dataField: 'EntityName',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Customer Legal Entity Name",
  };
  ServiceType: any = {
    lable: 'Service Type',
    formControlName: 'ServiceType',
    dataField: 'ServiceType',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Service Type",
  };
  PaymentRef: any = {
    lable: 'Payment Reference',
    formControlName: 'PaymentRef',
    dataField: 'PaymentRef',
    placeholder: "Enter Payment Reference",
    isReadOnly: false,
  };
  InvoiceRemark: any = {
    lable: "Invoice Remark",
    formControlName: "InvoiceRemark",
    dataField: "InvoiceRemark",
    isRequired: false,
    type: "textarea",
    placeholder: "Enter Invoice Remark",
  };
  TermsConditions: any = {
    lable: "Terms & Conditions",
    formControlName: "TermsConditions",
    dataField: "TermsConditions",
    isRequired: false,
    type: "textarea",
    placeholder: "Enter Terms & Conditions",
  };

  LRtableDetails: ITableModel = {
    emptyDataMSg: "Charges not added yet. Please add Charges.",
    columnDetails: [
      // { columnName: "LR#", dataFieldName: "ConsignmentNo", dataFieldName2: "Location", divType: "UserDetails", },
      { columnName: "Particulars", dataFieldName: "LRNumberDesc", dataFieldName2: "LocationDesc", divType: "SalesInv", width: '20%' },
      // { columnName: "LR Date", dataFieldName: "ConsignmentDate", divType: "", },
      { columnName: "Charge", dataFieldName: "ChargeCode", dataFieldName2: 'Remark', divType: "InvCharge", width: '20%' },
      // { columnName: "Charge", dataFieldName: "ChargeCode", divType: "", },
      // { columnName: "Location", dataFieldName: "Location", divType: "", },
      // { columnName: "Vehicle No", dataFieldName: "VehicleNo", divType: "", },
      { columnName: "Unit", dataFieldName: "Unit", divType: "", width: '10%' },
      { columnName: "GST", dataFieldName: "ChargedGST", divType: "", width: '5%' },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Rate", dataFieldName: "Rate", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Discount", dataFieldName: "Discount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Amount", dataFieldName: "Amount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      // { columnName: "Remark", dataFieldName: "Remark", divType: "", alignType: "right", },
      { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '5%' },
    ],
    data: [],
    footerData: [
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Sub Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'CGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'SGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'IGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Round Off', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { LRNo: '', ConsignmentDate: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Net Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
    ],
    actionList: [
      { label: 'Edit', command: (event?: any) => console.log(event) },
      { label: 'Delete', }
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  WithoutLRtableDetails: ITableModel = {
    emptyDataMSg: "Charge not added yet. Please add Charge.",
    columnDetails: [
      { columnName: "Charge", dataFieldName: "ChargeCode", dataFieldName2: 'Remark', divType: "InvCharge", width: '30%' },
      // { columnName: "Location", dataFieldName: "Location", divType: "", },
      // { columnName: "Vehicle No", dataFieldName: "VehicleNo", divType: "", },
      { columnName: "Unit", dataFieldName: "Unit", divType: "", width: '10%' },
      { columnName: "GST", dataFieldName: "ChargedGST", divType: "", width: '10%' },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Rate", dataFieldName: "Rate", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Discount", dataFieldName: "Discount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Amount", dataFieldName: "Amount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    ],
    data: [],
    footerData: [
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Sub Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'CGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'SGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'IGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Round Off', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Net Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
    ],
    actionList: [
      { label: 'Edit', command: (event?: any) => console.log(event) },
      { label: 'Delete', }
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  OrdertableDetails: ITableModel = {
    emptyDataMSg: "Charge not added yet. Please add Charge.",
    // columnDetails: [
    //   { columnName: "Order", dataFieldName: "OrderNo", divType: "", },
    //   { columnName: "Charge", dataFieldName: "ChargeCode", divType: "", },
    //   { columnName: "Location", dataFieldName: "Location", divType: "", },
    //   { columnName: "Vehicle No", dataFieldName: "VehicleNo", divType: "", },
    //   { columnName: "Unit", dataFieldName: "Unit", divType: "", alignType: "right", },
    //   { columnName: "GST", dataFieldName: "ChargedGST", divType: "", alignType: "right", },
    //   { columnName: "Qty", dataFieldName: "Quantity", divType: "", alignType: "right", },
    //   { columnName: "Rate", dataFieldName: "Rate", divType: "", alignType: "right", },
    //   { columnName: "Discount", dataFieldName: "Discount", divType: "", alignType: "right", },
    //   { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right", },
    //   { columnName: "Remark", dataFieldName: "Remark", divType: "", alignType: "right", },
    //   { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    // ],
    columnDetails: [
      { columnName: "Order No", dataFieldName: "OrderNoDesc", dataFieldName2: "LocationDesc", divType: "SalesInv", width: '20%' },
      { columnName: "Charge", dataFieldName: "ChargeCode", dataFieldName2: 'Remark', divType: "InvCharge", width: '20%' },
      { columnName: "Unit", dataFieldName: "Unit", divType: "", width: '10%' },
      { columnName: "GST", dataFieldName: "ChargedGST", divType: "", width: '5%' },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Rate", dataFieldName: "Rate", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Discount", dataFieldName: "Discount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Amount", dataFieldName: "Amount", divType: "CurrencyDiv", alignType: "right", width: '10%' },
      { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '5%' },
    ],
    data: [],
    footerData: [
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Sub Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'CGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'SGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'IGST', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Round Off', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
      { OrderNo: '', ChargeCode: '', Location: '', VehicleNo: '', Unit: 'Net Total', ChargedGST: '', Quantity: "", Rate: "", Discount: "", Amount: 0.00, Remark: '' },
    ],
    actionList: [
      { label: 'Edit', command: (event?: any) => console.log(event) },
      { label: 'Delete', }
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  // Added by priya - 11/05/2026 - cn(PRIYA-MAY26-002)
  ExpenseTable: ITableModel = {
    emptyDataMSg: "No Data Found.",
    columnDetails: [
      { columnName: "Booking No", dataFieldName: "FCNumber", divType: "", },
      { columnName: "Charge", dataFieldName: "Charge", divType: "", },
      { columnName: "Product Weight", dataFieldName: "ProductWeight", divType: "", },
      { columnName: "Product Qty", dataFieldName: "ProductQuantity", divType: "", },
      { columnName: "Vehicle Type", dataFieldName: "VehicleType", divType: "", },
      { columnName: "Qty", dataFieldName: "qty", divType: "", },
      { columnName: "Rate", dataFieldName: "Rate", divType: "", alignType: "right", },
      { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right", },
      // { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    ],
    data: [],
    footerData: [],
    isColumnNameShow: true,
    isShowFooterData: false,
  };

  // Added by priya - 11/05/2026 - cn(PRIYA-MAY26-002)
  BillsTable: ITableModel = {
    emptyDataMSg: "No Data Found.",
    columnDetails: [
      { columnName: "Bill No", dataFieldName: "BillNo", divType: "", },
      { columnName: "Charge", dataFieldName: "chargeaccount", divType: "", },
      { columnName: "BasedOn", dataFieldName: "basedon", divType: "", },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "", alignType: 'right' },
      { columnName: "Rate", dataFieldName: "rate", divType: "", alignType: 'right' },
      { columnName: "CGST", dataFieldName: "CGSTAmount", divType: "", alignType: 'right' },
      { columnName: "SGST", dataFieldName: "SGSTAmount", divType: "", alignType: "right", },
      { columnName: "IGST", dataFieldName: "IGSTAmount", divType: "", alignType: "right", },
      { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right", },
      // { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    ],
    data: [],
    footerData: [],
    isColumnNameShow: true,
    isShowFooterData: false,
  };

  IsAuthorized: any;
  LRNo: any = {
    lable: "",
    formControlName: 'LRNo',
    dataField: 'LRNo',
    isValueBind: true,
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Select LR Number",
  };
  ChargeCode: any = {
    lable: "",
    formControlName: 'ChargeCode',
    dataField: 'ChargeCode',
    isValueBind: true,
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Select Charge",
  };
  Unit: any = {
    lable: "",
    formControlName: 'Unit',
    dataField: 'Unit',
    isValueBind: true,
    isRequired: true,
    placeholder: "Select Unit",
  };
  Qty: any = {
    lable: "",
    formControlName: 'Quantity',
    dataField: 'Quantity',
    isRequired: true,
    placeholder: "Qty",
    type: 'number'
  };
  Rate: any = {
    lable: "",
    formControlName: 'Rate',
    dataField: 'Rate',
    isRequired: true,
    placeholder: "Rate",
    type: 'number'
  };
  Discount: any = {
    lable: "",
    formControlName: 'Discount',
    dataField: 'Discount',
    isRequired: false,
    placeholder: "Discount",
    type: 'number'
  };
  Remark: any = {
    lable: "",
    formControlName: 'Remark',
    dataField: 'Remark',
    isRequired: false,
    placeholder: "Remark",
  };
  AddInvoice: any = {};
  ConsignmentDate: any = {
    lable: "",
    formControlName: 'ConsignmentDate',
    dataField: 'ConsignmentDate',
    isRequired: false,
    placeholder: "LR Date",
    isReadOnly: true
  };
  Location: any = {
    lable: "",
    formControlName: 'Location',
    dataField: 'Location',
    isRequired: false,
    placeholder: "Location",
    isReadOnly: true
  };
  VehicleNo: any = {
    lable: "",
    formControlName: 'Vehicle',
    dataField: 'Vehicle',
    isRequired: false,
    placeholder: "Vehicle No",
    isReadOnly: true
  };
  ChargedGST: any = {
    lable: "",
    formControlName: 'ChargedGST',
    dataField: 'ChargedGST',
    isRequired: false,
    placeholder: "GST ",
    isReadOnly: true
  };
  Amount: any = {
    lable: "",
    formControlName: 'Amount',
    dataField: 'Amount',
    isRequired: true,
    placeholder: "Amount",
    type: 'number',
    isReadOnly: true
  };
  OrderNo: any = {
    lable: "",
    formControlName: 'OrdersByVehicleId',
    dataField: 'OrdersByVehicleId',
    isValueBind: true,
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Select Order No",
  };
  ConsignmentNo: any = {
    lable: "",
    formControlName: 'ConsignmentNo',
    dataField: 'ConsignmentNo',
    isValueBind: true,
    isSearchByApi: true,
    placeholder: "Select Consignment No",
  };
  findLR: any = {};
  CancelReason: any = {
    lable: "Reason",
    formControlName: 'CancelReason',
    dataField: 'CancelReason',
    isValueBind: true,
    isSearchByApi: true,
    placeholder: "Select Reason",
    isRequired: true,
  };

  constructor(
    private _appService: appService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private _navService: NavService,
    private modalService: NgbModal,
    private router: Router,
    private toastr: ToastrService,
    private mobileDetectionService: MobileDetectionService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private commonService: CommonService,
  ) {
    SalesInvoiceFormComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // this.selectedId = this.route.snapshot.paramMap.get('id');
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.selectedId = this.route.snapshot.params['id'];;

    // this.getTransactionType();
    this.LoadTaxApplicable();
    this.getSystemSettingForheadBranchInvoiceNumbring();
    this.GetSalseUploadChargesOnOffSysSetting();
    this.GetTaxNameSysSetting();
    this.GetLoadAdditionalMasterSysSetting();
    this.GetLoginCompanyData();
    this.GetInvoiceType(); // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)

    this.TransType.dropdownList = [];
    this.TransType.dropdownList.push(
      { value: 0, name: 'Operational' },
      { value: 1, name: 'Non Operational' },
      { value: 2, name: 'Orders' }
    );

    this.Unit.dropdownList = [];
    this.Unit.dropdownList.push(
      { value: 'Weight', name: 'Weight' },
      { value: 'Vehicle', name: 'Vehicle' },
      { value: 'Shipment', name: 'Shipment' },
      { value: 'Package', name: 'Package' },
      { value: 'Hours', name: 'Hours' },
      { value: 'Day', name: 'Day' },
      { value: 'Unit', name: 'Unit' },
      { value: 'Shortage', name: 'Shortage' },
      { value: 'FixedKMMonth', name: 'FixedKMMonth' },
      { value: 'KGS', name: 'Kgs' },
      { value: 'MT', name: 'MT' },
      { value: 'Invoice', name: 'Invoice' },
      { value: 'CBM', name: 'CBM' },
      { value: 'Per Truck-Per Invoice', name: 'Per Truck-Per Invoice' },
    );
    if (this.hostUrl === 'https://accounts.ifreightbox.net/') {
      this.Unit.dropdownList.push(
        { value: 'USD', name: 'USD' },
        { value: 'EURO', name: 'EURO' },
        { value: 'LKR', name: 'LKR' }
      );
    }

    setTimeout(() => {
      if (this.selectedId !== 'undefined' && this.selectedId !== 'null') {
        this.isFormPendingInvoicePage = false;
        this.data.Id = this.selectedId;
        this.GetInvoiceById();
      } else {
        this.inv_pending_objData = JSON.parse(localStorage.getItem("inv_objData"));
        this.inv_pending_arrayData = JSON.parse(localStorage.getItem("inv_arrayData"));
        this.isFormPendingInvoicePage = true;

        this.InvoiceNo = 'Auto';
        this.data.ChargeType = this.inv_pending_objData.InvoiceTypeName;
        this.data.InvoiceTypeId = this.inv_pending_objData.InvoiceType;
        this.data.CustomerId = this.inv_pending_objData.Customer;
        this.data[this.InvoiceDate.dataField] = new Date();
        this.setDropdownData(this.BillToParty, this.inv_pending_objData.BillToParty, this.inv_pending_objData.BillToPartyName);
        this.getChangedValue(this.inv_pending_objData.BillToParty, this.BillToParty);
        this.getChangedValue(this.inv_pending_objData.Customer, 'Customer');
        this.OnGenerateInvocie();
        this.data.IsWithoutLR = 0;
      }
    }, 500);

    this._navService.navItem$.subscribe((item) => {
      if (this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id && window.location.pathname == "/sales-invoice-new/edit/" + this.selectedId) {
        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
        this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
        this.GetInvoiceById();
        this.GetLoginCompanyData();
      }
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize = (): void => {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  OnGenerateInvocie() {
    Helpers.setLoading(true);
    this.saveDisable = true;
    this.authorizeDisable = true;
    this.postDisable = true;

    this._appService.GetByTwoId("Sales", "in_checkBillToPartyGst", this.CompanyId, this.inv_pending_objData.BillToParty).subscribe((response) => {
      if (response[0].isGst == 'Yes') {
        this._appService.GetBySevenId("Sales", "GetVendorName", "", 0, this.TenantId, "Invoice", this.inv_pending_objData.BillToParty, this.inv_pending_objData.InvoiceType, this.CompanyId).subscribe((res_checkCustAdd) => {
          Helpers.setLoading(true);
          if (res_checkCustAdd.Total > 0) {
            if (res_checkCustAdd.Results[0].Address == '' || res_checkCustAdd.Results[0].Address == null) {
              this.toastr.error("Add Billing Address for selected party !", "error");
            } else {
              this.GeneratedInvoice = [];
              if (this.inv_pending_arrayData != null) {
                if (this.inv_pending_arrayData != 0) {
                  this.GeneratedInvoice = this.inv_pending_arrayData;

                  let res = [];
                  var CheckForSameCompany: boolean = false;
                  this.GeneratedInvoice.map(function (item) {
                    var existItem = res.find((x) => x.CompanyId != item.CompanyId);
                    if (existItem) {
                      CheckForSameCompany = true;
                    } else {
                      res.push(item);
                    }
                  });
                  if (CheckForSameCompany == false || this.headBranchInvoiceNumbringFlag == true) {
                    if (this.headBranchInvoiceNumbringFlag == false) {
                      this.CompanyId = this.GeneratedInvoice[0].CompanyId;
                    }
                    this.SaveGeneratedInvoiceData();
                  }
                } else {
                  this.SaveGeneratedInvoiceData();

                  setTimeout(() => {
                    if (this.inv_pending_arrayData.length == 0) {
                      if (this.SalseUploadChargesOnOffFlag) {
                        setTimeout(() => {
                          this.SaveInvoiceData();
                        }, 500);
                      }
                    }
                  }, 1000);

                }
              } else {
                this.SaveGeneratedInvoiceData();
              }
            }
          } else {
            Helpers.setLoading(true);
            this.toastr.error("Add Billing Address for selected party !", "error");
          }
        },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
      } else {
        Helpers.setLoading(false);
        this.toastr.error('Please add GstNo', "error");
      }
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  SaveGeneratedInvoiceData() {
    Helpers.setLoading(true);
    this.data.InvoiceDetails = [];
    this.data.InvoiceDetails = this.GeneratedInvoice;
    this.data.CompanyId = this.CompanyId;
    this.data.CustomerId = this.inv_pending_objData.Customer;
    this.data.InvoiceTypeId = this.inv_pending_objData.InvoiceType;
    this.data.se2OrderRefNoValue = this.inv_pending_objData.se2_pcOrderRefNo;
    this.data.UserId = this.userId;

    this._appService.Post("Sales", "SaveInvoice_BySp", this.data).subscribe((response) => {
      if (response[0].isDone == 'OK') {
        this.data.ChangeInvoiceNumber = "true";
        this.data.Id = response[0].invoiceId;
        this.GetCustomerDetail();
      } else {
        this.toastr.error(response[0].isDone, "error");
      }
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  GetCustomerDetail() {
    this._appService.GetBySevenId("Sales", "GetVendorName", "", 0, this.TenantId, "Invoice", this.inv_pending_objData.BillToParty, this.inv_pending_objData.InvoiceType, this.CompanyId).subscribe((response) => {
      this.CustomerDetail = response.Results[0];
      var inv_date: any = moment(this.CustomerDetail.InvoiceDate, "DD-MM-YYYY");
      this.data[this.InvoiceDate.dataField] = new Date(inv_date);
      var DueDate: any = moment(this.data[this.InvoiceDate.dataField], "DD-MM-YYYY").add(this.CustomerDetail.PaymentTerms, "days");
      this.data[this.InvoiceDueDate.dataField] = new Date(DueDate);
      this.data[this.CreditDays.dataField] = this.CustomerDetail.PaymentTerms;
      this.GetGeneratedInvoiceList();
    },
      (err) => {
        this.toastr.error("Error while fetching Customer Details !", "error");
      }
    );
  }

  GetGeneratedInvoiceList() {
    Helpers.setLoading(true);
    var GSTType = "";
    if (this.SelectedCompanyGSTCode == this.CustomerDetail.GstFirtTwoNo || this.CustomerDetail.TaxPreference == 'TaxableInternational') {
      if ((this.CustomerDetail.TaxExemptionsReason == 'SEZ Customer Taxable' && this.CustomerDetail.IsTaxable == true && this.SalesFlag == false) || this.CustomerDetail.TaxPreference == 'TaxableInternational') {
        GSTType = "Inter";
      } else {
        GSTType = "Intra";
      }
    } else {
      GSTType = "Inter";
    }

    this.data.GSTType = GSTType;
    this._appService.GetByTwoId("Sales", "GetGeneratedInvoiceList_IndentChargesNew", this.CompanyId, this.data.Id).subscribe((response) => {
      this.GeneratedInvoiceList = response;

      var uniqueCNDArray: any = []
      if (this.hostUrl == 'https://ksh.ifreightbox.net/') {
        this.GeneratedInvoiceList.forEach(element => {
          if (element.TransportName.toUpperCase() == 'FTL' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
            var last2: string = element.ConsignmentNo.slice(-2);
            if (last2.toUpperCase() != '-A') {
              element.UnitRate = 0;
            }
          }
          if (element.TransportName.toUpperCase() == 'LTL' && element.Unit.toUpperCase() == 'Weight' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
            // var last2: string = element.ConsignmentNo.slice(-2);
            // var totalBookingData = this.GeneratedInvoiceList.filter((arr) => arr.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2) == element.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2));
            // var totalAmountArray = totalBookingData.filter((arr) => arr.ConsignmentNo.slice(-2).toUpperCase() == '-A');
            // if (totalAmountArray.length != 0) {
            //   var totalAmount = parseFloat((parseFloat(totalAmountArray[0].Quantity) * parseFloat(totalAmountArray[0].UnitRateFix == undefined ? totalAmountArray[0].UnitRate : totalAmountArray[0].UnitRateFix)).toFixed(2));
            //   var totalDived = parseFloat(totalBookingData.length) * parseFloat(element.Quantity);
            //   totalDived = totalDived == 0 ? 1 : totalDived;
            //   element.UnitRate = parseFloat((totalAmount / totalDived).toFixed(2));
            // }
            element.Quantity = parseFloat((element.PaidWeight).toFixed(2));
          }
        });
      }
      uniqueCNDArray = this.uniqueArray2(this.GeneratedInvoiceList);
      if (this.GeneratedInvoice.length != uniqueCNDArray.length) {
        this._appService.GetBySevenId("Sales", "GetGeneratedInvoiceList", this.CompanyId, this.inv_pending_objData.Customer, this.inv_pending_objData.InvoiceType, this.data.Id, GSTType, null, null).subscribe((response) => {
          if (this.GeneratedInvoiceList.lenght == 0) {
            this.GeneratedInvoiceList = response;

          } else {
            response.forEach(element => {
              var existItem = uniqueCNDArray.find((x) => x == element.ConsignmentNoteDetailId);
              //#region for round trip
              if (element.Remark == 'Second Trip') {
                element.Quantity = 0;
                element.UnitRate = 0;
                element.Amount = 0;
              }
              //#endregion
              if (!existItem) {
                this.GeneratedInvoiceList.push(element);
              }
            });
          }
          if (this.hostUrl == 'https://ksh.ifreightbox.net/') {
            this.GeneratedInvoiceList.forEach(element => {
              if (element.UnitRateFix == undefined) {
                element.UnitRateFix = element.UnitRate;
              }
              if (element.TransportName.toUpperCase() == 'FTL' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
                var last2: string = element.ConsignmentNo.slice(-2);
                if (last2.toUpperCase() != '-A') {
                  element.UnitRate = 0;
                }
              }
              if (element.TransportName.toUpperCase() == 'LTL' && element.Unit.toUpperCase() == 'Weight' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
                // var last2: string = element.ConsignmentNo.slice(-2);
                // var totalBookingData = this.GeneratedInvoiceList.filter((arr) => arr.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2) == element.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2));
                // var totalAmountArray = totalBookingData.filter((arr) => arr.ConsignmentNo.slice(-2).toUpperCase() == '-A');
                // if (totalAmountArray.length != 0) {
                //   var totalAmount = parseFloat((parseFloat(totalAmountArray[0].Quantity) * parseFloat(totalAmountArray[0].UnitRateFix == undefined ? totalAmountArray[0].UnitRate : totalAmountArray[0].UnitRateFix)).toFixed(2));
                //   var totalDived = parseFloat(totalBookingData.length) * parseFloat(element.Quantity);
                //   totalDived = totalDived == 0 ? 1 : totalDived;
                //   element.UnitRate = parseFloat((totalAmount / totalDived).toFixed(2));
                // }
                element.Quantity = parseFloat((element.PaidWeight).toFixed(2));
              }
            });
          }
          uniqueCNDArray = [];
          uniqueCNDArray = this.uniqueArray2(this.GeneratedInvoiceList);
          if (this.GeneratedInvoice.length != uniqueCNDArray.length) {
            this._appService.GetBySevenId("Sales", "GetGeneratedInvoiceList_DefaultChargesNew", this.CompanyId, this.inv_pending_objData.Customer, this.inv_pending_objData.InvoiceType, this.data.Id, GSTType, null, null).subscribe((response) => {
              if (this.GeneratedInvoiceList.lenght == 0) {
                this.GeneratedInvoiceList = response;
              } else {
                response.forEach(element => {
                  var existItem = uniqueCNDArray.find((x) => x == element.ConsignmentNoteDetailId);
                  if (!existItem) {
                    this.GeneratedInvoiceList.push(element);
                  }
                });
              }
              if (this.hostUrl == 'https://ksh.ifreightbox.net/') {
                this.GeneratedInvoiceList.forEach(element => {
                  if (element.TransportName.toUpperCase() == 'FTL' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
                    var last2: string = element.ConsignmentNo.slice(-2);
                    if (last2.toUpperCase() != '-A') {
                      element.UnitRate = 0;
                    }
                  }
                  if (element.TransportName.toUpperCase() == 'LTL' && element.Unit.toUpperCase() == 'Weight' && element.bookingType.toUpperCase() != 'MULTIPICKUP') {
                    // var last2: string = element.ConsignmentNo.slice(-2);
                    // var totalBookingData = this.GeneratedInvoiceList.filter((arr) => arr.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2) == element.ConsignmentNo.substring(0, arr.ConsignmentNo.length - 2));
                    // var totalAmountArray = totalBookingData.filter((arr) => arr.ConsignmentNo.slice(-2).toUpperCase() == '-A');
                    // if (totalAmountArray.length != 0) {
                    //   var totalAmount = parseFloat((parseFloat(totalAmountArray[0].Quantity) * parseFloat(totalAmountArray[0].UnitRateFix == undefined ? totalAmountArray[0].UnitRate : totalAmountArray[0].UnitRateFix)).toFixed(2));
                    //   var totalDived = parseFloat(totalBookingData.length) * parseFloat(element.Quantity);
                    //   totalDived = totalDived == 0 ? 1 : totalDived;
                    //   element.UnitRate = parseFloat((totalAmount / totalDived).toFixed(2));
                    // }
                    element.Quantity = parseFloat((element.PaidWeight).toFixed(2));
                  }
                });
              }
              this.CalculateGSTForAll();
              Helpers.setLoading(false);
            },
              (err) => {
                Helpers.setLoading(false);
                this.toastr.error("Error occurred while fetching data !", "error");
              });
          } else {
            this.CalculateGSTForAll();
            Helpers.setLoading(false);
          }
        },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error("Error occurred while fetching data !", "error");
          });
      } else {
        this.CalculateGSTForAll();
        Helpers.setLoading(false);
      }
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  CalculateGSTForAll() {
    let SGST: any = 0.0;
    let CGST: any = 0.0;
    let IGST: any = 0.0;

    this.fotData.TotalQty = 0;
    this.fotData.TotalAmount = 0;
    this.fotData.NetTotalAmount = 0;
    this.fotData.RoundOfAmount = 0;
    this.fotData.TotalCGST = 0;
    this.fotData.TotalSGST = 0;
    this.fotData.TotalIGST = 0;
    this.fotData.TotalDiscount = 0;

    this.GeneratedInvoiceList.forEach((element) => {
      SGST = 0.0;
      CGST = 0.0;
      IGST = 0.0;
      if (element.Discount == null || element.Discount == undefined || element.Discount == "") {
        element.Discount = 0;
      }
      element.TaxDisplayName;
      element.Amount = element.Quantity * element.UnitRate;
      element.Amount = element.Amount - element.Discount;
      if (element.IsGSTApplicable == true) {
        if (this.CustomerDetail.IsTaxable == true) {
          if (element.CGST != null && element.CGST != 0) {
            CGST = element.Amount * (element.CGST / 100);
          }
          if (element.SGST != null && element.SGST != 0) {
            SGST = element.Amount * (element.SGST / 100);
          }
          if (element.IGST != null && element.IGST != 0) {
            IGST = element.Amount * (element.IGST / 100);
          }
        } else {
          element.TaxDisplayName = "NA";
          element.ChargedGSTId = null;
        }
      } else {
        element.TaxDisplayName = "NA";
        element.ChargedGSTId = null;
      }

      element.CGSTAmount = parseFloat(CGST.toFixed(2));
      element.SGSTAmount = parseFloat(SGST.toFixed(2));
      element.IGSTAmount = parseFloat(IGST.toFixed(2));

      this.fotData.TotalAmount += parseFloat(element.Amount);
      this.fotData.TotalDiscount += parseFloat(element.Discount);
      this.fotData.TotalQty += element.Quantity ? parseFloat(element.Quantity) : 0;
      this.fotData.TotalCGST += parseFloat(CGST);
      this.fotData.TotalSGST += parseFloat(SGST);
      this.fotData.TotalIGST += parseFloat(IGST);

      if (this.data.IsWithoutLR == 0) {
        var consNo = element.ConsignmentNo ? element.ConsignmentNo.toString().trim().toUpperCase() : '';
        var consDate = element.ConsignmentDate ? element.ConsignmentDate.toString().trim() : '';
        element.LRNumberDesc = [consNo, consDate].filter(function (x) { return x; }).join('   ');

        var vehicle = element.VehicleNo ? element.VehicleNo.toString().trim().toUpperCase() : '';
        var location = element.Location ? element.Location.toString().trim().toUpperCase() : '';
        element.LocationDesc = [location, vehicle].filter(function (x) { return x; }).join('   ');
      }

      if (this.data.IsWithoutLR == 2) {
        var consNo = element.OrderNo ? element.OrderNo.toString().trim().toUpperCase() : '';
        var consDate = element.ConsignmentDate ? element.ConsignmentDate.toString().trim() : '';
        element.OrderNoDesc = [consNo, consDate].filter(function (x) { return x; }).join('   ');

        var vehicle = element.VehicleNo ? element.VehicleNo.toString().trim().toUpperCase() : '';
        var location = element.Location ? element.Location.toString().trim().toUpperCase() : '';
        element.LocationDesc = [location, vehicle].filter(function (x) { return x; }).join('   ');
      }
    });

    this.fotData.TotalQty = parseFloat(this.fotData.TotalQty);
    this.fotData.TotalCGST = parseFloat(this.fotData.TotalCGST);
    this.fotData.TotalSGST = parseFloat(this.fotData.TotalSGST);
    this.fotData.TotalIGST = parseFloat(this.fotData.TotalIGST);
    this.fotData.NetTotalAmount = (this.fotData.TotalAmount + this.fotData.TotalCGST + this.fotData.TotalSGST + this.fotData.TotalIGST);
    if (this.hostUrl != 'https://ksh.ifreightbox.net/') {
      this.fotData.RoundOfAmount = parseFloat((Math.round(this.fotData.NetTotalAmount) - this.fotData.NetTotalAmount).toFixed(2));
      this.fotData.NetTotalAmount = Math.round(this.fotData.NetTotalAmount);
    }
    this.data.RoundOffValue = this.fotData.RoundOfAmount;

    console.log('1st', this.GeneratedInvoiceList);
    this.LRtableDetails.data = this.GeneratedInvoiceList;
    this.WithoutLRtableDetails.data = this.GeneratedInvoiceList;
    this.OrdertableDetails.data = this.GeneratedInvoiceList;
    console.log('this.OrdertableDetails.data', this.OrdertableDetails.data);

    this.updateFooterAmounts(this.OrdertableDetails, this.fotData, this.GeneratedInvoiceList);
    this.updateFooterAmounts(this.LRtableDetails, this.fotData, this.GeneratedInvoiceList);
    this.updateFooterAmounts(this.WithoutLRtableDetails, this.fotData, this.GeneratedInvoiceList);
  }

  ValidateRequiredFieldOnSave() {
    var IsAllDataDone: any = true;
    if (!this.data[this.InvoiceDate.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.data[this.CreditDays.dataField]) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.warning(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  IsSaveDone: boolean = false;
  SaveInvoiceData() {
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    this.saveDisable = true;
    this.authorizeDisable = true;
    this.postDisable = true;
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      this.data.ActualCustomer = this.inv_pending_objData.Customer;
      this.data.CustomerId = this.inv_pending_objData.BillToParty;
      this.data.Id = this.data.Id;
      this.data.InvoiceNumber = this.data.InvoiceNumber ? this.data.InvoiceNumber : null;
      this.data.InvoiceDate = this.data[this.InvoiceDate.dataField];
      this.data.InvoicePaymentTerms = this.data[this.CreditDays.dataField];
      this.data.InvoiceDueDate = this.data[this.InvoiceDueDate.dataField];
      this.data.SalesPerson = this.data[this.RefNo.dataField];
      this.data.PaymentTerm = this.data[this.TermsConditions.dataField];
      this.data.Remark = this.data[this.InvoiceRemark.dataField];
      this.data.PaymentReference = this.data[this.PaymentRef.dataField];

      if (this.AdditionalMasterFlag == true) {
        this.data.BoschLegalEntityName = this.data[this.EntityName.dataField];
        this.data.BoschBusinessDivisionName = this.data[this.DivisionName.dataField];
        this.data.BoschServiceTypeName = this.data[this.ServiceType.dataField];
        this.data.BoschWarehouseName = this.data[this.WarehouseName.dataField];
        this.data.BoschUsername = this.data[this.BoschUsername.dataField];
      } else {
        this.data.BoschLegalEntityName = null;
        this.data.BoschBusinessDivisionName = null;
        this.data.BoschServiceTypeName = null;
        this.data.BoschWarehouseName = null;
        this.data.BoschUsername = null;
      }
      //end
      this.data.TotalAmount = this.fotData.NetTotalAmount;
      this.data.InvoiceDetails = [];
      let i = 0;
      this.GeneratedInvoiceList.forEach((element) => {
        this.data.InvoiceDetails[i] = {};
        this.data.InvoiceDetails[i] = element;
        this.data.InvoiceDetails[i].Rate = element.UnitRate;
        this.data.InvoiceDetails[i].ChargedGST = element.ChargedGST;
        this.data.InvoiceDetails[i].Id = "";
        i++;
      });
      this.data.ChangeInvoiceNumber = this.data.ChangeInvoiceNumber;
      this._appService.GetByTwoId("sales", "checkBillToParty", this.inv_pending_objData.Customer, this.inv_pending_objData.BillToParty).
        subscribe(res => {
          if (res[0].ActualCustomerId == 'OK' && res[0].BillToPartyId == 'OK') {
            this.data.UserId = this.userId;
            this._appService
              .Post("Sales", "SaveInvoice_BySp", this.data)
              .subscribe(
                (response) => {
                  if (response[0].isDone == 'OK') {
                    this.CustomerDetail.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
                    this.data.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
                    this.CustomerDetail.InvoiceNumber = response[0].invoiceNumber;
                    this.data.InvoiceNumber = response[0].invoiceNumber;
                    this.data.ChangeInvoiceNumber = "false";

                    this.IsSaveDone = true;
                    this.isFormSubmit = false;
                    this.GetInvoiceById();

                    const Saved = this.translate.instant("ALERTMESSAGES.Saved");
                    this.toastr.success(Saved, "Success");
                  } else {
                    this.toastr.error(response[0].isDone, "error");
                  }
                  this.saveDisable = true;
                  this.authorizeDisable = true;
                  this.postDisable = true;

                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error(err._body.replace(/"/g, ""), "error");
                }
              );
          } else {
            this.saveDisable = true;
            Helpers.setLoading(false);
            if (res[0].ActualCustomerId != 'OK' && res[0].BillToPartyId != 'OK') {
              this.toastr.error(res[0].ActualCustomerId, "error");
              this.toastr.error(res[0].BillToPartyId, "error");
            }
            else if (res[0].ActualCustomerId != 'OK') {
              this.toastr.error(res[0].ActualCustomerId, "error");
            }
            else if (res[0].BillToPartyId != 'OK') {
              this.toastr.error(res[0].BillToPartyId, "error");
            }
          }
        }, (err) => {
          this.saveDisable = true;
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        })
    } else {
      $("#BtnPCSave").prop("disabled", false);
      Helpers.setLoading(false);
      this.toastr.error("Please Fill All the Details", "error");
    }
  }

  GetInvoiceById() {
    this._appService.GetById("Sales", "NewGetInvoiceById", this.data.Id).subscribe(response => {
      this.InvoiceNo = response.Table[0].InvoiceNumber;
      this.StatusName = response.Table[0].NewInvoiceStatus;
      this.data = response.Table[0];

      this.data[this.InvoiceDate.dataField] = this.data.InvoiceDate;
      this.data[this.CreditDays.dataField] = this.data.PaymentTerms;
      this.data[this.InvoiceDueDate.dataField] = this.data.InvoiceDueDate;
      this.data[this.RefNo.dataField] = this.data.InvoiceRefNo;
      this.data[this.BoschUsername.dataField] = this.data.BoschUsername;
      this.data[this.DivisionName.dataField] = this.data.BoschBusinessDivisionName;
      this.data[this.EntityName.dataField] = this.data.BoschLegalEntityName;
      this.data[this.ServiceType.dataField] = this.data.BoschServiceTypeName;
      this.data[this.PaymentRef.dataField] = this.data.PaymentReference;
      this.data[this.TransType.dataField] = this.data.IsWithoutLR == null ? 0 : this.data.IsWithoutLR;
      this.IsWithoutLR = this.data.IsWithoutLR == null ? 0 : this.data.IsWithoutLR;
      this.data[this.InvoiceRemark.dataField] = this.data.Remark
      this.data[this.TermsConditions.dataField] = this.data.PaymentTerm
      this.data[this.RefNo.dataField] = this.data.SalesPerson;
      this.data.Id = response.Table[0].Id;

      this.notesTransactionId = this.data.Id;  // added by yash 06-05-2026
      this.notesTransactionType = 'Sales Invoice';  // added by yash 06-05-2026

      // this.LRtableDetails.data = response.Table1;
      // this.WithoutLRtableDetails.data = response.Table1;
      // this.OrdertableDetails.data = response.Table1;
      this.GeneratedInvoiceList = response.Table1;

      this.getChangedValue(this.data.CustomerId, 'Customer');
      this.setDropdownData(this.BillToParty, this.data.CustomerId, this.data.CustomerName);
      this.getChangedValue(this.data.CustomerId, this.BillToParty);

      this.GetCustomerDetailById();

      this.inv_pending_objData.InvoiceTypeName = this.data.ChargeType;
      this.inv_pending_objData.InvoiceType = this.data.InvoiceTypeId;
      this.inv_pending_objData.Customer = this.data.CustomerId;
      this.inv_pending_objData.BillToParty = this.data.CustomerId;

      setTimeout(() => {
        this.CalculateGSTForAll();
      }, 1500);

      //added by fahim 16-1-2026 :)
      if (this.data && this.data.IsAuthorized === true) {
        this.RemoveActionColumn();
      }
      // this.setDropdownData(this.WarehouseName, this.data.BoschWarehouseName, this.data.BoschWarehouse);
      // this.updateFooterAmounts(this.OrdertableDetails, null, response.Table1);
      // this.updateFooterAmounts(this.LRtableDetails, null, response.Table1);
      // this.updateFooterAmounts(this.WithoutLRtableDetails, null, response.Table1);
    },
      (err) => {
        this.toastr.error("Error While Getting Edit data", err);
      }
    );
  }

  GetCustomerDetailById() {
    this._appService.GetBySevenId("Sales", "GetVendorName", "", 0, this.TenantId, "Invoice", this.data.CustomerId, this.data.InvoiceTypeId, this.CompanyId).subscribe((response) => {
      this.CustomerDetail = {};
      this.CustomerDetail = response.Results[0];
    },
      (err) => {
        this.toastr.error("Error while fetching Customer Details !", "error");
      }
    );
  }

  updateFooterAmounts(tableDetails: any, fotData: any, orderListDetails: any) {
    tableDetails.footerData[0].Quantity = this.fotData.TotalQty.toFixed(2);  // Sub Total
    tableDetails.footerData[0].Amount = this.fotData.TotalAmount.toFixed(2);  // Sub Total
    tableDetails.footerData[1].Amount = this.fotData.TotalCGST.toFixed(2);  // CGST
    tableDetails.footerData[2].Amount = this.fotData.TotalSGST.toFixed(2);  // SGST
    tableDetails.footerData[3].Amount = this.fotData.TotalIGST.toFixed(2);  // IGST
    tableDetails.footerData[4].Amount = this.fotData.RoundOfAmount.toFixed(2);  // Round Off
    tableDetails.footerData[5].Amount = this.fotData.NetTotalAmount.toFixed(2);  // Net Amount

    // for (const item of orderListDetails) {
    //   tableDetails.footerData[0].Amount += item.Amount;
    //   tableDetails.footerData[1].Amount += item.CGSTAmount;
    //   tableDetails.footerData[2].Amount += item.SGSTAmount;
    //   tableDetails.footerData[3].Amount += item.IGSTAmount;
    // }

    // tableDetails.footerData[5].Amount =
    //   tableDetails.footerData[0].Amount +
    //   tableDetails.footerData[1].Amount +
    //   tableDetails.footerData[2].Amount +
    //   tableDetails.footerData[3].Amount;

    // tableDetails.footerData[4].Amount = Math.round(tableDetails.footerData[5].Amount) - tableDetails.footerData[5].Amount;

    // tableDetails.footerData[5].Amount = Math.round(tableDetails.footerData[5].Amount);

    // tableDetails.footerData.forEach((item: any) => {
    //   item.Amount = parseFloat(item.Amount).toLocaleString('en-IN', {
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2
    //   });
    // });
  }

  DeleteInvoiceById(Id) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this order?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Sales", "DeleteInvoiceById", this.data.Id).subscribe((response) => {
            Helpers.setLoading(false);
            this.SaveDeletedTransactionHistory(this.data.Id);
            this.BackToList();
            this.toastr.success("Successfully Deleted !", "Success");
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("An error occured while deleting data !", "error");
            }
          );
        }
        dialogRef.close();
      });
    });
  }

  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = 'Sales';
    obj.UserId = this.userId;
    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe((response) => {
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  setDropdownData(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.data[field.dataField] = value;
  }

  setDropdownDataLR(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.AddInvoice[field.dataField] = value;
  }

  getChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'TransType') {
      this.data[data.dataField] = value;
      this.IsWithoutLR = value;
    } if (data == 'Customer') {
      this.data[data.dataField] = newValue;
      this._appService.GetByTwoId("Sales", "inv_changeCustomerData", this.data.Id, newValue).subscribe((response) => {
        if (response.length > 0) {
          this.data.CustomerName = response[0].CustomerName;
          this.data.Address = response[0].Address;
          this.data.City = response[0].City;
          this.data.State = response[0].State;
          this.data.PostalCode = response[0].PostalCode;
          // this.data.ContactPerson = response[0].CustomerName;
          this.data.Phone = response[0].Phone;
          this.data.Email = response[0].Email;
        }
      },
        (err) => {
          this.toastr.error("An error occured while fetching data !", "error");
        }
      );
    } if (data.dataField == 'BillToParty') {
      this.data[data.dataField] = newValue;
      this._appService.GetByTwoId("Sales", "inv_changeCustomerData", this.data.Id, newValue).subscribe((response) => {
        if (response.length > 0) {
          this.data.BtP_Address = response[0].Address;
          this.data.BtP_City = response[0].City;
          this.data.BtP_State = response[0].State;
          this.data.BtP_PostalCode = response[0].PostalCode;
          this.data.BtP_GST = response[0].GST;
          this.data.BtP_IsTaxable = response[0].IsTaxable;
          // this.data.BtP_ContactPerson = response[0].CustomerName;
          this.data.BtP_Phone = response[0].Phone;
          this.data.BtP_Email = response[0].Email;
          this.data.BtP_ExemptionReason = response[0].ExemptionReason;
        }
      },
        (err) => {
          this.toastr.error("An error occured while fetching data !", "error");
        }
      );
    } else {
      this.data[data.dataField] = newValue;
    }
  }

  CancelReasonName: any;
  getChangedValueLR(value, data, isEdit = false) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'LRNo') {
      this.AddInvoice[data.dataField] = newValue;
      this.AddInvoice.ConsignmentDate = value.ConsignmentDate;
      this.AddInvoice.ConsignmentNoteDetailId = value.id;
      this.AddInvoice.ConsignmentNo = value.ConsignmentNo;
      this.AddInvoice.LRNum = value.ConsignmentNo;
      this.AddInvoice.TransporterId = value.TransporterId;
      this.AddInvoice.VehicleType = value.VehicleType;
      this.AddInvoice.Package = value.Quantity;
      this.AddInvoice.ShortageQuantity = value.ShortageQuantity;
      if (isEdit == false) {
        this.AddInvoice.Quantity = value.Quantity;
      }
      this.AddInvoice.PaidWeight = value.PaidWeight;
      this.AddInvoice.FromCity = value.FromCity;
      this.AddInvoice.ToCity = value.ToCity;
      this.AddInvoice.Location = value.FromCity + " to " + value.ToCity;
      this.AddInvoice.FixedKMMonthQTY = value.FixedKMMonthQTY;
      this.AddInvoice.VehicleNo = value.VehicleNumber;
      this.AddInvoice.Vehicle = value.VehicleNo; + " - " + value.ContainerNo;
      this.AddInvoice.ContainerNo = value.ContainerNo;
      this.AddInvoice.ConsignmentId = value.id;
    } else if (data.dataField == 'ChargeCode') {
      this.AddInvoice[data.dataField] = newValue;
      this.AddInvoice.ChargedGSTId = value.ChargedGSTId;
      this.AddInvoice.ChargedGST = value.TaxDisplayName;
      this.AddInvoice.ChargeCode = value.text;
      this.AddInvoice.IsGSTApplicable = value.IsGSTApplicable;
      this.AddInvoice.SGST = value.SGST;
      this.AddInvoice.CGST = value.CGST;
      this.AddInvoice.IGST = value.IGST;
    } else if (data.dataField == 'Unit') {
      this.AddInvoice[data.dataField] = newValue;
      if (newValue == "Weight") {
        this.AddInvoice.Quantity = this.AddInvoice.PaidWeight;
      } else if (newValue == "Package") {
        this.AddInvoice.Quantity = this.AddInvoice.Package;
      } else if (newValue == "Vehicle") {
        this.AddInvoice.Quantity = 1;
      } else if (newValue == "Shortage") {
        this.AddInvoice.Quantity = this.AddInvoice.ShortageQuantity;
      } else if (newValue == "FixedKMMonth") {
        this.AddInvoice.Quantity = this.AddInvoice.FixedKMMonthQTY;
      } else {
        this.AddInvoice.Quantity = 1;
      }
      this.OnChangeAddInvoice();
    } else if (data.dataField == 'Quantity' || data.dataField == 'Rate' || data.dataField == 'Discount') {
      this.AddInvoice[data.dataField] = newValue;
      this.OnChangeAddInvoice();
    } else if (data.dataField == 'OrdersByVehicleId') {
      this.AddInvoice[data.dataField] = newValue;
      this.AddInvoice.OrderNo = value.OrderNo;
      this.AddInvoice.ConsignmentDate = value.ConsignmentDate;
      this.AddInvoice.ConsignmentNoteDetailId = null;
      this.AddInvoice.OrdersByVehicleId = value.id;
      this.AddInvoice.ConsignmentNo = value.OrderNo;
      this.AddInvoice.LRNumber = value.OrderNo;
      this.AddInvoice.TransporterId = value.TransporterId;
      this.AddInvoice.VehicleType = value.VehicleType;
      this.AddInvoice.Package = value.Quantity;
      if (isEdit == false) {
        this.AddInvoice.Quantity = value.Quantity;
      }
      this.AddInvoice.ShortageQuantity = value.ShortageQuantity;
      this.AddInvoice.PaidWeight = value.PaidWeight;
      this.AddInvoice.FromCity = value.FromCity;
      this.AddInvoice.ToCity = value.ToCity;
      this.AddInvoice.VehicleNo = value.VehicleNo;
      this.AddInvoice.ContainerNo = value.ContainerNo;
      this.AddInvoice.Location = value.FromCity + " to " + value.ToCity;
    } else if (data.dataField == 'ConsignmentNo') {
      this.findLR[data.dataField] = newValue;
      this.GetInv_statusbyconsignment(value.name);
    } else if (data.dataField == 'CancelReason') {
      this.CancelReasonName = newValue;
    } else {
      this.AddInvoice[data.dataField] = newValue;
    }
  }

  statusbyconsignment: any = [];
  GetInv_statusbyconsignment(TripQuery) {
    this._appService
      .GetByTwoId(
        "Sales",
        "GetInv_statusbyconsignment",
        TripQuery,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          this.statusbyconsignment = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
  }

  TransactionType = [
    { value: 0, name: 'Operational' },
    { value: 1, name: 'Non Operational' },
    { value: 2, name: 'Orders' }
  ]

  getTransactionType() {
    this.TransType.dropdownList = this.TransactionType
  }

  getBillToParty(value, isScrollDown = false) {
    this.BillToParty.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.BillToParty.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageByTenantId('Sales', 'GetCompanydata', value, pageNo, this.TenantId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.BillToParty.dropdownList.length) {
        dropdownList = dropdownList.concat(this.BillToParty.dropdownList);
        this.BillToParty = { ...this.BillToParty, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.BillToParty = { ...this.BillToParty, dropdownList: [...dropdownList] });
      this.BillToParty.isSearch = false;
    }),
      (error => {
        this.BillToParty.isSearch = false;
      })
  }

  getBoschUsername(value, isScrollDown = false) {
    this.BoschUsername.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.BoschUsername.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageCompanyId('Common', 'GetBoschUsernameSelect2', value, pageNo, this.CompanyId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.BoschUsername.dropdownList.length) {
        dropdownList = dropdownList.concat(this.BoschUsername.dropdownList);
        this.BoschUsername = { ...this.BoschUsername, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.BoschUsername = { ...this.BoschUsername, dropdownList: [...dropdownList] });
      this.BoschUsername.isSearch = false;
    }),
      (error => {
        this.BoschUsername.isSearch = false;
      })
  }

  getDivisionName(value, isScrollDown = false) {
    this.DivisionName.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.DivisionName.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPage('Common', 'GetBoschBusinessDivisionNameSelect2', value, pageNo).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.DivisionName.dropdownList.length) {
        dropdownList = dropdownList.concat(this.DivisionName.dropdownList);
        this.DivisionName = { ...this.DivisionName, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.DivisionName = { ...this.DivisionName, dropdownList: [...dropdownList] });
      this.DivisionName.isSearch = false;
    }),
      (error => {
        this.DivisionName.isSearch = false;
      })
  }

  getWarehouseName(value, isScrollDown = false) {
    this.WarehouseName.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.WarehouseName.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageByTenantId('Common', 'GetBoschWarehouseSelect2', value, pageNo, this.TenantId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.WarehouseName.dropdownList.length) {
        dropdownList = dropdownList.concat(this.WarehouseName.dropdownList);
        this.WarehouseName = { ...this.WarehouseName, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.WarehouseName = { ...this.WarehouseName, dropdownList: [...dropdownList] });
      this.WarehouseName.isSearch = false;
    }),
      (error => {
        this.WarehouseName.isSearch = false;
      })
  }

  getEntityName(value, isScrollDown = false) {
    this.EntityName.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.EntityName.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPage('Common', 'GetBoschLeaglEntityNameSelect2', value, pageNo).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.EntityName.dropdownList.length) {
        dropdownList = dropdownList.concat(this.EntityName.dropdownList);
        this.EntityName = { ...this.EntityName, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.EntityName = { ...this.EntityName, dropdownList: [...dropdownList] });
      this.EntityName.isSearch = false;
    }),
      (error => {
        this.EntityName.isSearch = false;
      })
  }

  getServiceType(value, isScrollDown = false) {
    this.ServiceType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ServiceType.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPage('Common', 'GetServiceTypeNameSelect2', value, pageNo).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.ServiceType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ServiceType.dropdownList);
        this.ServiceType = { ...this.ServiceType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ServiceType = { ...this.ServiceType, dropdownList: [...dropdownList] });
      this.ServiceType.isSearch = false;
    }),
      (error => {
        this.ServiceType.isSearch = false;
      })
  }

  SaveData() {
  }

  OnClickPaymentReceipt() {
    this.showPayment = !this.showPayment;
    if (this.showPayment == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        this._appService.GetById("Sales", "GetPaymentReceiptSummary", this.data.Id).subscribe(
          (response) => {
            this.ReceiptSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          })
      }
    }
  }

  OnClickJournalEntry() {
    this.showJournalEntry = !this.showJournalEntry;
    if (this.showJournalEntry == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        Helpers.setLoading(true);
        this._appService.GetById("Sales", "GetJournalEntrySummary", this.data.Id).subscribe(
          (response) => {
            this.JVSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          });
        Helpers.setLoading(false);
      }
    }
  }

  OnClickAudit() {
    this.showAudit = !this.showAudit;
    if (this.showAudit == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        Helpers.setLoading(true);
        var pageURL = "SalesInvoice";
        this._appService.GetByTwoId("Common", "getAuditTrailData", this.data.Id, pageURL).subscribe((response) => {
          this.AuditData = response[0];
          Helpers.setLoading(false);
        },
          (error) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured", error);
          });
      }
    }
  }

  OnClickMailHistory() {
    this.showMailHistory = !this.showMailHistory;
    let obj: any = {}
    obj.Transaction = this.InvoiceNo
    if (this.showMailHistory == true) {
      this._appService.Post("Sales", "GetMailHistory", obj).subscribe(
        (response) => {
          this.mailHistoryList = response[0];
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        });
    }
  }

  BackToList() {
    if (this.isFormPendingInvoicePage) {
      this.router.navigateByUrl(`/pending-invoice-consignment`);
    } else {
      this.router.navigateByUrl(`/sales-invoice-new`);
    }
  }

  toggleActionDropdown() {
    this.dropdownActionVisible = !this.dropdownActionVisible;
  }

  showDropdown() {
    this.dropdownActionVisible = true;
  }

  hideDropdown() {
    this.dropdownActionVisible = false;
  }

  togglePrintDropdown() {
    this.dropdownPrintVisible = !this.dropdownPrintVisible;
  }

  showPrintDropdown() {
    this.dropdownPrintVisible = true;
  }

  hidePrintDropdown() {
    this.dropdownPrintVisible = false;
  }

  newToggleDrop() {
    this.newDropdownVisible = !this.newDropdownVisible;
  }

  uniqueArray2(arr) {
    var a = [];
    for (var i = 0, l = arr.length; i < l; i++) {
      if (a.length == 0) {
        a.push(arr[i].ConsignmentNoteDetailId);
      } else {
        var duplicate = 0;
        for (var j = 0; j < a.length; j++) {
          if (a[j] == arr[i].ConsignmentNoteDetailId) {
            duplicate = 1;
          }
        }
        if (duplicate == 0) {
          a.push(arr[i].ConsignmentNoteDetailId);
        }
      }
    }
    return a;
  }

  getSystemSettingForheadBranchInvoiceNumbring() {
    this._appService.GetById("Common", "GetSystemSettingByName", "headBranchInvoiceNumbring").subscribe((response) => {
      if (response == "1") {
        this.headBranchInvoiceNumbringFlag = true;
      } else {
        this.headBranchInvoiceNumbringFlag = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  GetSalseUploadChargesOnOffSysSetting() {
    this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'SalseUploadChargesOnOff').subscribe((response) => {
      if (response[0].Value == "1") {
        this.SalseUploadChargesOnOffFlag = true;
      } else {
        this.SalseUploadChargesOnOffFlag = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      });
  }

  GetTaxNameSysSetting() {
    this._appService.GetByTwoId("Common", "GetSystemSettingByType", null, 'TaxName').subscribe((response) => {
      if (response[0].Value == "1") {
        this.SalesFlag = true;
      } else {
        this.SalesFlag = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      });
  }

  GetLoadAdditionalMasterSysSetting() {
    this._appService.GetById("Common", "GetSystemSettingByName", "AdditionalMaster").subscribe((response) => {
      if (response == '1') {
        this.AdditionalMasterFlag = true;
      } else {
        this.AdditionalMasterFlag = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      }
    );
  }

  CheckBranchPaymentLimit() { }

  AuthorizeExpense() { }

  @ViewChild('LRStatus') LRStatus: TemplateRef<any>;
  modalRef: any;
  onActionClick({ row, actionName, index }) {
    if (actionName == "Edit") {
      this.chargesEdit(row, index);
      // this.modalRef = this.modalService.open(this.Charges, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (actionName.trim() == "Delete") {
      this.RemoveCharge(row, index);
    }
  }

  // added by yash 06-05-2026
  onSelectItemNew(event: any) {

    console.log('Dropdown Event:', event);

    if (event.actionName === 'Notes') {

      this.notesTransactionType = 'Sales Invoice';
      this.notesTransactionId = this.data.Id;

      this.isNotesPanelOpen = false;

      setTimeout(() => {
        this.isNotesPanelOpen = true;
      }, 0);
    }
  }
  // end by yash 06-05-2026

  OpenLRStatusModal() {
    this.modalRef = this.modalService.open(this.LRStatus, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
  }

  editRow: any = {};
  chargesEdit(row: any, index: any) {
    this.AddInvoice = {};
    this.AddInvoice = row;
    this.editRow = row;
    this.GeneratedInvoiceList.splice(index, 1);
    // this.getChangedValueLR(
    //   this.AddInvoice.Unit,
    //   this.Unit
    // );
    // Call both APIs in parallel
    forkJoin([
      this.getLRListEdit(this.AddInvoice.ConsignmentNo),   // Observable
      this.getChargeListEdit(this.AddInvoice.ChargeCode),   // Observable
      this.getOrderListEdit(this.AddInvoice.OrderNo)
    ]).subscribe(([lrListResponse, chargeListResponse]) => {
      // Set dropdown data based on responses

      // After both API responses are processed
      if (this.LRNo.dropdownList.length > 0) {
        this.getChangedValueLR(
          this.LRNo.dropdownList[0],
          this.LRNo,
          true
        );
        var val = this.AddInvoice.ConsignmentNo + '  ' + this.AddInvoice.ConsignmentDate + '   ' + this.AddInvoice.Location + '   ' + this.AddInvoice.VehicleNo;
        this.setDropdownDataLR(this.LRNo, this.AddInvoice.ConsignmentNoteDetailId, val);
      }

      if (this.ChargeCode.dropdownList.length > 0) {
        this.getChangedValueLR(
          this.ChargeCode.dropdownList[0],
          this.ChargeCode
        );
        this.setDropdownDataLR(this.ChargeCode, this.AddInvoice.ChargeCode, this.AddInvoice.ChargeCode);
      }

      if (this.data.IsWithoutLR == 2) {
        if (this.OrderNo.dropdownList.length > 0) {
          this.getChangedValueLR(
            this.OrderNo.dropdownList[0],
            this.OrderNo,
            true
          );
          var val = this.AddInvoice.OrderNo + '  ' + this.AddInvoice.ConsignmentDate + '   ' + this.AddInvoice.Location;
          this.setDropdownDataLR(this.OrderNo, this.AddInvoice.OrdersByVehicleId, this.AddInvoice.val);
        }
      }
    });
  }

  onClickClear() {
    if (this.editRow) {
      this.AddInvoice = {};
      this.GeneratedInvoiceList.push(this.editRow);
      this.editRow = {};
    }
  }

  IsAddFormSubmitted: boolean = false;
  ValidateRequiredFieldOnAdd() {
    var IsAllDataDone: any = true;
    if (this.data.IsWithoutLR === 0) {
      if (!this.AddInvoice[this.LRNo.dataField]) {
        IsAllDataDone = false;
      }
    }
    if (this.data.IsWithoutLR === 2) {
      if (!this.AddInvoice[this.OrderNo.dataField]) {
        IsAllDataDone = false;
      }
    }
    if (!this.AddInvoice[this.ChargeCode.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.AddInvoice[this.Unit.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.AddInvoice[this.Qty.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.AddInvoice[this.Rate.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.AddInvoice[this.Amount.dataField]) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.warning(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  AllowSameChargeCodeonInv: boolean = false;
  doexist: boolean = false;
  async OnAddInvoice() {
    var flag = true;
    this.IsAddFormSubmitted = true;
    flag = this.ValidateRequiredFieldOnAdd();
    if (flag == true) {
      try { //using try catch .toPromise() so the function doesnt get skip 
        const response = await this._appService.GetByTwoParam(
          "Sales",
          "checkSameChargeforTrip",
          this.AddInvoice.ConsignmentNoteDetailId,
          this.AddInvoice.ChargeCode
        ).toPromise();
        this.doexist = response[0].doexist;
      } catch (err) {
        this.toastr.error("Error occurred while fetching Status data!", "error");
        flag = false;
      }

      if (this.AllowSameChargeCodeonInv == true) {
        for (let i = 0; i < this.GeneratedInvoiceList.length; i++) {

          if (
            this.GeneratedInvoiceList[i].ConsignmentNoteDetailId === this.AddInvoice.ConsignmentNoteDetailId &&
            this.GeneratedInvoiceList[i].ChargeCode === this.AddInvoice.ChargeCode || this.doexist == true
          ) {
            this.toastr.error("Same Charge cannot be added twice for trip!");
            flag = false;
            return;
          }

        }
      }

      if (this.IsWithoutLR == 1) {
        this.AddInvoice.ConsignmentDate = null;
        this.AddInvoice.ConsignmentNoteDetailId = null;
        this.AddInvoice.ConsignmentNo = null;
        this.AddInvoice.TransporterId = null;
        this.AddInvoice.VehicleType = null;
        this.AddInvoice.FromCity = null;
        this.AddInvoice.ToCity = null;
        this.AddInvoice.Location = null;
        this.AddInvoice.PaidWeight = 0;
        this.AddInvoice.LRNumber = "";
      }
      this.AddInvoice.UnitRate = this.AddInvoice.Rate;

      if (this.data.IsWithoutLR == 0) {
        var consNo = this.AddInvoice.ConsignmentNo ? this.AddInvoice.ConsignmentNo.toString().trim().toUpperCase() : '';
        var consDate = this.AddInvoice.ConsignmentDate ? this.AddInvoice.ConsignmentDate.toString().trim() : '';
        this.AddInvoice.LRNumberDesc = [consNo, consDate].filter(function (x) { return x; }).join('   ');

        var vehicle = this.AddInvoice.VehicleNo ? this.AddInvoice.VehicleNo.toString().trim().toUpperCase() : '';
        var location = this.AddInvoice.Location ? this.AddInvoice.Location.toString().trim().toUpperCase() : '';
        this.AddInvoice.LocationDesc = [location, vehicle].filter(function (x) { return x; }).join('   ');
      }

      if (this.data.IsWithoutLR == 2) {
        var consNo = this.AddInvoice.OrderNo ? this.AddInvoice.OrderNo.toString().trim().toUpperCase() : '';
        var consDate = this.AddInvoice.ConsignmentDate ? this.AddInvoice.ConsignmentDate.toString().trim() : '';
        this.AddInvoice.OrderNoDesc = [consNo, consDate].filter(function (x) { return x; }).join('   ');

        var vehicle = this.AddInvoice.VehicleNo ? this.AddInvoice.VehicleNo.toString().trim().toUpperCase() : '';
        var location = this.AddInvoice.Location ? this.AddInvoice.Location.toString().trim().toUpperCase() : '';
        this.AddInvoice.LocationDesc = [location, vehicle].filter(function (x) { return x; }).join('   ');
      }

      this.GeneratedInvoiceList.push(this.AddInvoice);
      this.AddInvoice = {};
      this.editRow = {};
      this.CalculateGSTForAll();
      this.IsAddFormSubmitted = false;
    }
  }

  OnChangeAddInvoice() {
    this.AddInvoice.Amount = this.AddInvoice.Quantity * parseFloat(this.AddInvoice.Rate || 1);
    this.AddInvoice.Amount = this.AddInvoice.Amount - parseFloat(this.AddInvoice.Discount || 0);
  }

  RemoveCharge(data, index,) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this record?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          SalesInvoiceFormComponent.that.onRemoveCharge(index);
        }
        dialogRef.close();
      });
    })
  }

  onRemoveCharge(index: any) {
    SalesInvoiceFormComponent.that.GeneratedInvoiceList.splice(index, 1);
    this.CalculateGSTForAll();
  }

  isDisabled: boolean = false;
  getLRList(value, isScrollDown = false) {
    this.LRNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.LRNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetQueryPageLR('Sales', 'inv_GetConsignmetListNew', value, pageNo, this.data.CustomerId, this.CompanyId, this.data.InvoiceTypeId, this.data.Id ? this.data.Id : null).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.LRNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.LRNo.dropdownList);
        this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] });
      this.LRNo.isSearch = false;
    }),
      (error => {
        this.LRNo.isSearch = false;
      })
  }

  getChargeList(value, isScrollDown = false) {
    this.ChargeCode.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ChargeCode.dropdownList.length / 20) + 1;
    }
    this._appService.GetQueryPageChargeList('Sales', 'GetChargeList', value, pageNo, this.data.InvoiceTypeId, this.TenantId, this.CompanyId, this.data.GSTType ? this.data.GSTType : null).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.ChargeCode.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ChargeCode.dropdownList);
        this.ChargeCode = { ...this.ChargeCode, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ChargeCode = { ...this.ChargeCode, dropdownList: [...dropdownList] });
      this.ChargeCode.isSearch = false;
    }),
      (error => {
        this.ChargeCode.isSearch = false;
      })
  }

  getLRListEdit(value: string, isScrollDown = false): Observable<any> {
    this.LRNo.isSearch = true;
    let pageNo = 1;

    if (isScrollDown === true) {
      pageNo = Math.ceil(this.LRNo.dropdownList.length / 20) + 1;
    }

    return this._appService.GetQueryPageLR(
      'Sales',
      'inv_GetConsignmetListNew',
      value,
      pageNo,
      this.data.CustomerId,
      this.CompanyId,
      this.data.InvoiceTypeId,
      this.data.Id ? this.data.Id : null
    ).pipe(
      tap(res => {
        res.Results.map(x => {
          x.name = x.text;
          x.value = x.id;
        });

        let dropdownList = [...res.Results];

        if (isScrollDown && res.Total > this.LRNo.dropdownList.length) {
          dropdownList = dropdownList.concat(this.LRNo.dropdownList);
          this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] };
        } else {
          this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] };
        }

        this.LRNo.isSearch = false;
      }),
      catchError(err => {
        this.LRNo.isSearch = false;
        return of(null); // prevent error from breaking forkJoin
      })
    );
  }

  getChargeListEdit(value: string, isScrollDown = false): Observable<any> {
    this.ChargeCode.isSearch = true;
    let pageNo = 1;

    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ChargeCode.dropdownList.length / 20) + 1;
    }

    return this._appService.GetQueryPageChargeList(
      'Sales',
      'GetChargeList',
      value,
      pageNo,
      this.data.InvoiceTypeId,
      this.TenantId,
      this.CompanyId,
      this.data.GSTType ? this.data.GSTType : null
    ).pipe(
      tap(res => {
        res.Results.map(x => {
          x.name = x.text;
          x.value = x.id;
        });

        let dropdownList = [...res.Results];

        if (isScrollDown && res.Total > this.ChargeCode.dropdownList.length) {
          dropdownList = dropdownList.concat(this.ChargeCode.dropdownList);
          this.ChargeCode = { ...this.ChargeCode, dropdownList: [...dropdownList] };
        } else {
          this.ChargeCode = { ...this.ChargeCode, dropdownList: [...dropdownList] };
        }

        this.ChargeCode.isSearch = false;
      }),
      catchError(err => {
        this.ChargeCode.isSearch = false;
        return of(null); // prevent error from breaking forkJoin
      })
    );
  }

  AuthorizeInvoice(d) {
    Helpers.setLoading(true);
    this._appService
      .GetByThreeId("Common", "AuthorizeTransaction", 1, this.data.Id, this.CompanyId)
      .subscribe(
        (response) => {
          this.IsAuthorized = true;
          this.GetInvoiceById();
          this.toastr.success("Invoice Authorized Successfully !", "Success");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    Helpers.setLoading(false);
  }

  PostInvoice() {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId("Sales", "PostInvoice", this.data.Id, this.CompanyId)
      .subscribe(
        (response) => {
          if (response == "Network is Unathorised") {
            this.toastr.info("Network is Unauthorised", "Info");
            return;
          }
          if (response == "Chart of Account not found") {
            this.toastr.info("Chart of Account not found", "Info");
            return;
          }
          // this.GetJVSummaryData();
          this.GetInvoiceById();
          this.toastr.success("Invoice Posted Successfully !", "Success");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    Helpers.setLoading(false);
  }

  getOrderList(value, isScrollDown = false) {
    this.OrderNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.OrderNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetQueryPageLR('Sales', 'inv_GetOrderListNew', value, pageNo, this.data.CustomerId, this.CompanyId, this.data.InvoiceTypeId, this.data.Id ? this.data.Id : null).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.OrderNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.OrderNo.dropdownList);
        this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] });
      this.OrderNo.isSearch = false;
    }),
      (error => {
        this.OrderNo.isSearch = false;
      })
  }

  getOrderListEdit(value: string, isScrollDown = false): Observable<any> {
    this.OrderNo.isSearch = true;
    let pageNo = 1;

    if (isScrollDown) {
      pageNo = Math.ceil(this.OrderNo.dropdownList.length / 20) + 1;
    }

    return this._appService.GetQueryPageLR(
      'Sales',
      'inv_GetOrderListNew',
      value,
      pageNo,
      this.data.CustomerId,
      this.CompanyId,
      this.data.InvoiceTypeId,
      this.data.Id ? this.data.Id : null
    ).pipe(
      tap(res => {
        res.map(x => {
          x.name = x.text;
          x.value = x.id;
        });

        let dropdownList = [...res];

        if (isScrollDown && res.Total > this.OrderNo.dropdownList.length) {
          dropdownList = dropdownList.concat(this.OrderNo.dropdownList);
          this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] };
        } else {
          this.OrderNo = { ...this.OrderNo, dropdownList: [...dropdownList] };
        }

        this.OrderNo.isSearch = false;
      }),
      catchError(error => {
        this.OrderNo.isSearch = false;
        return of(null); // So forkJoin/subscribe doesn't break
      })
    );
  }

  LoadTaxApplicable() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "IsTaxApplicable")
      .subscribe(
        (response) => {
          if (response == '1') {
            this.TaxApplicableFlag = true;
          } else {
            this.TaxApplicableFlag = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  PrintData: any = [];
  PrintDataModal: any = {};
  TaxApplicableFlag: boolean = false;
  RoundOfAmount: any = 0;
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  InvoiceTypeName: any;
  GetPrintData(Id, Type, ToDo) {
    Helpers.setLoading(true);
    this.PrintDataModal.InvoiceId = Id;
    if (Type == 'Detail1OnLatterPad' || Type == 'PDF_EInvoice' || Type == 'OnLatterPad_EInvoice') {
      this.PrintDataModal.Type = 'Detail1';
    } else {
      this.PrintDataModal.Type = Type;
    }

    if (Type == 'PrintInvoiceKSH' || Type == 'PrintInvoiceKSHSummary') {
      this._appService.Post("Sales", "GetPrintDataKSH", this.PrintDataModal).subscribe((response) => {
        this.PrintData = response;
        for (var i = 0; i < this.PrintData.length; i++) {
          let SGST: any = 0.0;
          let CGST: any = 0.0;
          let IGST: any = 0.0;
          this.PrintData[i].TotalQty = 0;
          this.PrintData[i].TotalDiscount = 0;
          this.PrintData[i].TotalAmount = 0;
          this.PrintData[i].NetTotalAmount = 0;
          this.PrintData[i].RoundOffValue = 0;
          this.PrintData[i].TotalCGST = 0;
          this.PrintData[i].TotalSGST = 0;
          this.PrintData[i].TotalIGST = 0;
          let UBSrNo = 1;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            //-----for Ub only------------
            if (Type == "AllInOne") {
              if (element.Unit == "Day") {
                element.SrNo = UBSrNo;
                UBSrNo++;
              }
            }
            //----------------------------
            if (
              element.Discount == null ||
              element.Discount == undefined ||
              element.Discount == ""
            ) {
              element.Discount = 0;
            }
            if (this.PrintData[i].IsTaxable == true) {
              if (element.CGST != null && element.CGST != 0) {
                CGST = element.Amount * (element.CGST / 100);
              }
              if (element.SGST != null && element.SGST != 0) {
                SGST = element.Amount * (element.SGST / 100);
              }
              if (element.IGST != null && element.IGST != 0) {
                IGST = element.Amount * (element.IGST / 100);
              }
            } else {
              element.ChargedGST = "NA";
            }
            this.PrintData[i].TotalAmount += element.Amount;
            this.PrintData[i].TotalDiscount += element.Discount;
            this.PrintData[i].TotalQty += element.Quantity;
            this.PrintData[i].TotalQty = Math.round(this.PrintData[i].TotalQty * 100) / 100;
            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
            CGST = 0.0;
            SGST = 0.0;
            IGST = 0.0;
          });
          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
          if (this.TaxApplicableFlag == true) {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount + this.PrintData[i].TotalCGST + this.PrintData[i].TotalSGST + this.PrintData[i].TotalIGST;
          } else {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount;
          }
          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
          if (this.hostUrl != 'https://ksh.ifreightbox.net/') {
            this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
            this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
          }
          this.PrintData[i].RoundOffValue = this.RoundOfAmount;

          this.PrintData[i].TotalTaxablevalue = 0;
          this.PrintData[i].ComponentToTalIGST = 0;
          this.PrintData[i].ComponentToTalSGST = 0;
          this.PrintData[i].ComponentToTalCGST = 0;
          this.PrintData[i].ComponentToTalGST = 0;
          if (Type != "AllInOne") {
            this.PrintData[i].ComponentRate.forEach((element) => {
              element.ComponentGST = 0;
              if (this.PrintData[i].IsTaxable != true) {
                element.IntegratedGST = 0;
                element.StateGST = 0;
                element.CentralGST = 0;
                element.IGSTRATE = 0;
                element.SGSTRATE = 0;
                element.CGSTRATE = 0;
              }
              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
              element.ComponentGST += element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;

              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
            });
            this.PrintData[i].ComponentToTalGST = this.PrintData[i].ComponentToTalIGST + this.PrintData[i].ComponentToTalSGST + this.PrintData[i].ComponentToTalCGST;
          } else {
            this.PrintData[i].TotalDamage = 0;
            this.PrintData[i].TotalShortage = 0;
            this.PrintData[i].TotalSealShort = 0;
            this.PrintData[i].TotalGoodQtyBoxes = 0;
            this.PrintData[i].TotalGoodQtyBottles = 0;
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              //--------------------Bottles---------------------
              let TotalBottles = element.Quantity * 12;
              let TotalGoodBottles = TotalBottles - (element.Damage + element.Shortage + element.SealShort);
              let TotalGoodQuantityBoxes: number = 0;
              TotalGoodQuantityBoxes = TotalGoodBottles % 12;
              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
              //--------------------Boxes-----------------------
              let DamageBoxes = Math.floor(TotalGoodBottles / 12);
              element.TotalGoodQuantityBoxes = DamageBoxes;
              //----------------------Total---------------------
              this.PrintData[i].TotalDamage = this.PrintData[i].TotalDamage + element.Damage;
              this.PrintData[i].TotalShortage = this.PrintData[i].TotalShortage + element.Shortage;
              this.PrintData[i].TotalSealShort = this.PrintData[i].TotalSealShort + element.SealShort;
              this.PrintData[i].TotalGoodQtyBoxes = this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
              this.PrintData[i].TotalGoodQtyBottles = this.PrintData[i].TotalGoodQtyBottles + element.TotalGoodQuantityBottles;
            });
          }
          if (Type == "AllInOne") {
            this.PrintData[i].TotalHaltingAmount = 0.0;
            this.PrintData[i].TotalProductQuantity = 0;
            this.PrintData[i].InvoiceDetails.forEach((element) => {
              if (element.Unit == "Day") {
                this.PrintData[i].TotalHaltingAmount =
                  this.PrintData[i].TotalHaltingAmount + element.Amount;
              }
            });
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              this.PrintData[i].TotalProductQuantity = this.PrintData[i].TotalProductQuantity + element.Quantity
            });
          }
        }
        if (ToDo == "Print") {
          this.InvoiceTypeName = Type;
          this.PrintFormatsChild.InvoiceId = Id;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          $("#PrintInvoicePCN").val("");
          this.PrintFormatsChild.PrintInvoice();
        }
      },
        (err) => {
          this.toastr.error("An error occured printing !", "error");
        }
      );
    } else {
      this._appService.Post("Sales", "GetPrintData", this.PrintDataModal).subscribe((response) => {

        this.PrintData = response;

        for (var i = 0; i < this.PrintData.length; i++) {

          let SGST: any = 0.0;

          let CGST: any = 0.0;

          let IGST: any = 0.0;



          this.PrintData[i].TotalQty = 0;

          this.PrintData[i].TotalDiscount = 0;

          this.PrintData[i].TotalAmount = 0;

          this.PrintData[i].NetTotalAmount = 0;

          this.PrintData[i].TotalCGST = 0;

          this.PrintData[i].TotalSGST = 0;

          this.PrintData[i].TotalIGST = 0;



          let UBSrNo = 1;



          this.PrintData[i].InvoiceDetails.forEach((element) => {

            //-----for Ub only------------

            if (Type == "AllInOne") {

              if (element.Unit == "Day") {

                element.SrNo = UBSrNo;

                UBSrNo++;

              }

            }

            //----------------------------

            if (

              element.Discount == null ||

              element.Discount == undefined ||

              element.Discount == ""

            ) {

              element.Discount = 0;

            }

            if (this.PrintData[i].IsTaxable == true) {

              if (element.CGST != null && element.CGST != 0) {

                CGST = element.Amount * (element.CGST / 100);

              }

              if (element.SGST != null && element.SGST != 0) {

                SGST = element.Amount * (element.SGST / 100);

              }

              if (element.IGST != null && element.IGST != 0) {

                IGST = element.Amount * (element.IGST / 100);

              }

            } else {

              element.ChargedGST = "NA";

            }



            this.PrintData[i].TotalAmount += element.Amount;

            this.PrintData[i].TotalDiscount += element.Discount;

            this.PrintData[i].TotalQty += element.Quantity;

            this.PrintData[i].TotalQty =

              Math.round(this.PrintData[i].TotalQty * 100) / 100;



            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));

            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));

            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));

            CGST = 0.0;

            SGST = 0.0;

            IGST = 0.0;

            // if (this.PrintData[i].ChargeType == 'Credit Note') {

            //   element.Amount = element.Amount * -1;

            // }

          });



          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));

          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));

          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));

          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));

          this.PrintData[i].NetTotalAmount =

            this.PrintData[i].TotalAmount +

            this.PrintData[i].TotalCGST +

            this.PrintData[i].TotalSGST +

            this.PrintData[i].TotalIGST;

          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));



          this.PrintData[i].TotalTaxablevalue = 0;

          this.PrintData[i].ComponentToTalIGST = 0;

          this.PrintData[i].ComponentToTalSGST = 0;

          this.PrintData[i].ComponentToTalCGST = 0;

          this.PrintData[i].ComponentToTalGST = 0;

          if (Type != "AllInOne") {

            this.PrintData[i].ComponentRate.forEach((element) => {

              element.ComponentGST = 0;

              if (this.PrintData[i].IsTaxable != true) {

                element.IntegratedGST = 0;

                element.StateGST = 0;

                element.CentralGST = 0;

                element.IGSTRATE = 0;

                element.SGSTRATE = 0;

                element.CGSTRATE = 0;

              }

              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;

              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;

              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;

              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;

              element.ComponentGST +=

                element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;


              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
              // end

            });

            this.PrintData[i].ComponentToTalGST =

              parseFloat((this.PrintData[i].ComponentToTalIGST +

                this.PrintData[i].ComponentToTalSGST +

                this.PrintData[i].ComponentToTalCGST).toFixed(2));

          } else {

            this.PrintData[i].TotalDamage = 0;

            this.PrintData[i].TotalShortage = 0;

            this.PrintData[i].TotalSealShort = 0;

            this.PrintData[i].TotalGoodQtyBoxes = 0;

            this.PrintData[i].TotalGoodQtyBottles = 0;



            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              //--------------------Bottles---------------------

              let TotalBottles = element.Quantity * 12;

              let TotalGoodBottles =

                TotalBottles -

                (element.Damage + element.Shortage + element.SealShort);

              let TotalGoodQuantityBoxes: number = 0;

              TotalGoodQuantityBoxes = TotalGoodBottles % 12;

              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;

              //--------------------Boxes-----------------------

              let DamageBoxes = Math.floor(TotalGoodBottles / 12);

              element.TotalGoodQuantityBoxes = DamageBoxes;

              //----------------------Total---------------------



              this.PrintData[i].TotalDamage =

                this.PrintData[i].TotalDamage + element.Damage;

              this.PrintData[i].TotalShortage =

                this.PrintData[i].TotalShortage + element.Shortage;

              this.PrintData[i].TotalSealShort =

                this.PrintData[i].TotalSealShort + element.SealShort;

              this.PrintData[i].TotalGoodQtyBoxes =

                this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;

              this.PrintData[i].TotalGoodQtyBottles =

                this.PrintData[i].TotalGoodQtyBottles +

                element.TotalGoodQuantityBottles;

            });

          }

          if (Type == "AllInOne") {

            this.PrintData[i].TotalHaltingAmount = 0.0;

            this.PrintData[i].TotalProductQuantity = 0;

            this.PrintData[i].InvoiceDetails.forEach((element) => {

              if (element.Unit == "Day") {

                this.PrintData[i].TotalHaltingAmount =

                  this.PrintData[i].TotalHaltingAmount + element.Amount;

              }

            });

            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              this.PrintData[i].TotalProductQuantity =

                this.PrintData[i].TotalProductQuantity + element.Quantity;

            });

          }

        }

        if (ToDo == "Print") {
          this.InvoiceTypeName = Type;
          this.PrintFormatsChild.InvoiceId = Id;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          $("#PrintInvoicePCN").val("");
          this.PrintFormatsChild.PrintInvoice();
          //end

        }
      },

        (err) => {

          this.toastr.error(err._body.replace(/"/g, ""), "error");

        }

      );
    }

  }

  getLRConsignmentList(value, isScrollDown = false) {
    this.ConsignmentNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ConsignmentNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageCompanyId('Sales', 'inv_Consigmeentstatus', value, pageNo, this.CompanyId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.ConsignmentNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ConsignmentNo.dropdownList);
        this.ConsignmentNo = { ...this.ConsignmentNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ConsignmentNo = { ...this.ConsignmentNo, dropdownList: [...dropdownList] });
      this.ConsignmentNo.isSearch = false;
    }),
      (error => {
        this.ConsignmentNo.isSearch = false;
      })
  }

  //added by vithu 24-12-2025
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  SelectedCompanyLogoImg: any;

  GetLoginCompanyData() {
    this.SelectedComapnyName = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedComapnyName;
    this.SelectedCompanyAdd = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyAdd;
    this.SelectedCompanyCIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyCIN;
    this.SelectedCompantGSTIN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompantGSTIN;
    this.SelectedCompanyGSTCode = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).GSTCode;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyPAN = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).SelectedCompanyPAN;

    $(".SalesLogoImg").attr(
      "src",
      environment.apiUrl + this.SelectedCompanyLogo
    );

    this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
  }

  OnDownloadClick(Data, Type, ToDo) {
    Helpers.setLoading(true);
    if (Type == "PrintInvoiceAnnexureMR4Movement") {
      this._appService
        .GetByTwoId(
          "Sales",
          "inv_DownloadInvoiceAnnexureMR4MovementKSH",
          Data,
          Type
        )
        .subscribe(
          (response) => {
            $("#DownloadInvoice").val("");
            this.DownloadFile(response);
            Helpers.setLoading(false);
          },
          (err) => {
            $("#DownloadInvoice").val("");
            Helpers.setLoading(false);
            this.toastr.error("An error occured Downaloding !", "error");
          }
        );
    } else {
      this.GetPrintData(Data, Type, ToDo);
      setTimeout(() => {
        for (var i = 0; i < this.PrintData.length; i++) {
          this.PrintData[i].SelectedComapnyName = this.SelectedComapnyName;
          this.PrintData[i].SelectedCompanyCIN = this.SelectedCompanyCIN;
          this.PrintData[i].SelectedCompantGSTIN = this.SelectedCompantGSTIN;
          this.PrintData[i].SelectedCompanyAdd = this.SelectedCompanyAdd;
          this.PrintData[i].SelectedCompanyPAN = this.SelectedCompanyPAN;
          if (Type == "Summary") {
            this._appService
              .Post("Sales", "ExportInvoiceSummaryData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "Detail") {
            this._appService
              .Post("Sales", "ExportInvoiceDetailData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "AllInOne") {
            this._appService
              .Post("Sales", "ExportUBBillData", this.PrintData[i])
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
          if (Type == "PrintInvoiceAnnexureformatGeneralKSH") {
            this._appService
              .Post(
                "Sales",
                "DownloadInvoiceAnnexureformatGeneralKSH",
                this.PrintData[i]
              )
              .subscribe(
                (response) => {
                  $("#DownloadInvoice").val("");
                  this.DownloadFile(response);
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error("An error occured Downaloding !", "error");
                }
              );
          }
        }
      }, 500);
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileSalesReport").attr("href", url);
    $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadFileSalesReport"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  Generate_EInvoice(Id) {
    Helpers.setLoading(true);
    $("#Btn_eInvoice").prop("disabled", true);
    this._appService
      .GetByThreeId(
        "Sales",
        "inv_GetDataForEInvoiceData",
        Id,
        this.CompanyId,
        this.userId
      )
      .subscribe(
        (response) => {
          if (response.responceMes == "OK") {
            this.toastr.success("Successfully generate e-invoice", "Success");
            this.data.IsEInvoiceDone = true;
            this.data.IRNNumber = response.IRNNo;
            this.data.EinvoicePdfLink = response.EInvoicePDF;
            $("#Btn_cancle_eInvoice").prop("disabled", false);
          } else {
            $("#Btn_eInvoice").prop("disabled", false);
            this.toastr.error(response.responceMes, "Error");
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          $("#Btn_eInvoice").prop("disabled", false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  @ViewChild('CancelEInvoice') CancelEInvoice: TemplateRef<any>;
  open_cancleEInvoiceMode() {
    this.modalRef = this.modalService.open(this.CancelEInvoice, {
      centered: true,
      size: 'lg'
    });
  }

  GetCancelReason(value, isScrollDown = false) {
    this.CancelReason.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.CancelReason.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageForReason('ReasonMaster', 'GetSelect2ReasonList', value, pageNo, 'Order').subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.CancelReason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.CancelReason.dropdownList);
        this.CancelReason = { ...this.CancelReason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.CancelReason = { ...this.CancelReason, dropdownList: [...dropdownList] });
      this.CancelReason.isSearch = false;
    }),
      (error => {
        this.CancelReason.isSearch = false;
      })
  }

  Cancle_EInvoice(Id) {
    if (!this.CancelReasonName) {
      this.toastr.error('Please select reason', 'Error');
      return;
    }

    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Sales",
        "inv_CancleEInvoiceData",
        Id,
        this.CompanyId,
        $("#txtCancellationReason").text()
      )
      .subscribe(
        (response) => {
          if (response.responceMes == "OK") {
            this.toastr.success("Successfully cancle e-invoice", "Success");
            this.data.IsEInvoiceDone = false;
          } else {
            this.toastr.error(response.responceMes, "Error");
          }
          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }
  //added by fahim 16-1-2026 :)
  RemoveActionColumn() {
    if (!this.data || this.data.IsWithoutLR === null || this.data.IsWithoutLR === undefined) {
      return;
    }

    const removeActions = function (columns) {
      if (!columns || !Array.isArray(columns)) {
        return [];
      }
      return columns.filter(function (col) {
        return col.columnName !== 'Actions';
      });
    };

    switch (this.data.IsWithoutLR) {
      case 0:
        this.LRtableDetails.columnDetails =
          removeActions(this.LRtableDetails.columnDetails);
        break;

      case 1:
        this.WithoutLRtableDetails.columnDetails =
          removeActions(this.WithoutLRtableDetails.columnDetails);
        break;

      case 2:
        this.OrdertableDetails.columnDetails =
          removeActions(this.OrdertableDetails.columnDetails);
        break;
    }
  }

  // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  UpdateInvoice(IsCreateNew: boolean = false) {
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      this.data.ActualCustomer = this.inv_pending_objData.Customer;
      this.data.CustomerId = this.inv_pending_objData.BillToParty;
      this.data.InvoiceNumber = null;
      this.data.InvoiceDate = this.data[this.InvoiceDate.dataField];
      this.data.InvoicePaymentTerms = this.data[this.CreditDays.dataField];
      this.data.InvoiceDueDate = this.data[this.InvoiceDueDate.dataField];
      this.data.SalesPerson = this.data[this.RefNo.dataField];
      this.data.PaymentTerm = this.data[this.TermsConditions.dataField];
      this.data.Remark = this.data[this.InvoiceRemark.dataField];
      this.data.PaymentReference = this.data[this.PaymentRef.dataField];
      this.data.InvoiceRefId = this.data.Id
      this.data.UserId = this.userId

      if (this.AdditionalMasterFlag == true) {
        this.data.BoschLegalEntityName = this.data[this.EntityName.dataField];
        this.data.BoschBusinessDivisionName = this.data[this.DivisionName.dataField];
        this.data.BoschServiceTypeName = this.data[this.ServiceType.dataField];
        this.data.BoschWarehouseName = this.data[this.WarehouseName.dataField];
        this.data.BoschUsername = this.data[this.BoschUsername.dataField];
      } else {
        this.data.BoschLegalEntityName = null;
        this.data.BoschBusinessDivisionName = null;
        this.data.BoschServiceTypeName = null;
        this.data.BoschWarehouseName = null;
        this.data.BoschUsername = null;
      }
      //end
      this.data.TotalAmount = this.fotData.NetTotalAmount;
      this.data.InvoiceDetails = [];
      let i = 0;
      this.GeneratedInvoiceList.forEach((element) => {
        this.data.InvoiceDetails[i] = {};
        this.data.InvoiceDetails[i] = element;
        this.data.InvoiceDetails[i].Rate = element.UnitRate;
        this.data.InvoiceDetails[i].ChargedGST = element.ChargedGST;
        this.data.InvoiceDetails[i].Id = "";
        i++;
      });
      this.data.ChangeInvoiceNumber = this.data.ChangeInvoiceNumber;
      this._appService.Post("Sales", "SaveInvoice_BySp", this.data).subscribe(
        (response) => {
          if (response[0].isDone == 'OK') {
            this.CustomerDetail.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.data.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.CustomerDetail.InvoiceNumber = response[0].invoiceNumber;
            this.data.InvoiceNumber = response[0].invoiceNumber;
            this.data.ChangeInvoiceNumber = "false";
            this.data.Id = response[0].invoiceId;

            this.IsSaveDone = true;
            this.isFormSubmit = false;
            if (IsCreateNew == true) {
              this.GetInvoiceById();
            }

            const Saved = this.translate.instant("ALERTMESSAGES.Saved");
            this.toastr.success(Saved, "Success");
          } else {
            this.toastr.error(response[0].isDone, "error");
          }
          this.CopyAndCreateNewDisable = false;
          this.authorizeDisable = true;
          this.postDisable = true;

          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    } else {
      $("#BtnPCSave").prop("disabled", false);
      Helpers.setLoading(false);
      this.toastr.error("Please Fill All the Details", "error");
    }
  }

  // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  GenerateCreditNote() {
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      this.data.ActualCustomer = this.inv_pending_objData.Customer;
      this.data.CustomerId = this.inv_pending_objData.BillToParty;
      this.data.InvoiceNumber = null;
      this.data.InvoiceDate = this.data[this.InvoiceDate.dataField];
      this.data.InvoicePaymentTerms = this.data[this.CreditDays.dataField];
      this.data.InvoiceDueDate = this.data[this.InvoiceDueDate.dataField];
      this.data.SalesPerson = this.data[this.RefNo.dataField];
      this.data.PaymentTerm = this.data[this.TermsConditions.dataField];
      this.data.Remark = this.data[this.InvoiceRemark.dataField];
      this.data.PaymentReference = this.data[this.PaymentRef.dataField];
      this.data.InvoiceRefId = this.data.Id
      this.data.InvoiceTypeId = this.InvoiceTypeList.find(x => x.ChargeType === 'Credit Note').id;
      this.data.Id = null;
      this.data.UserId = this.userId

      if (this.AdditionalMasterFlag == true) {
        this.data.BoschLegalEntityName = this.data[this.EntityName.dataField];
        this.data.BoschBusinessDivisionName = this.data[this.DivisionName.dataField];
        this.data.BoschServiceTypeName = this.data[this.ServiceType.dataField];
        this.data.BoschWarehouseName = this.data[this.WarehouseName.dataField];
        this.data.BoschUsername = this.data[this.BoschUsername.dataField];
      } else {
        this.data.BoschLegalEntityName = null;
        this.data.BoschBusinessDivisionName = null;
        this.data.BoschServiceTypeName = null;
        this.data.BoschWarehouseName = null;
        this.data.BoschUsername = null;
      }
      //end
      this.data.TotalAmount = this.fotData.NetTotalAmount;
      this.data.InvoiceDetails = [];
      let i = 0;
      this.GeneratedInvoiceList.forEach((element) => {
        this.data.InvoiceDetails[i] = {};
        this.data.InvoiceDetails[i] = element;
        this.data.InvoiceDetails[i].Rate = element.UnitRate;
        this.data.InvoiceDetails[i].ChargedGST = element.ChargedGST;
        this.data.InvoiceDetails[i].Id = "";
        i++;
      });
      this.data.ChangeInvoiceNumber = this.data.ChangeInvoiceNumber;
      this._appService.Post("Sales", "SaveInvoice_BySp", this.data).subscribe(
        (response) => {
          if (response[0].isDone == 'OK') {
            this.CustomerDetail.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.data.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.CustomerDetail.InvoiceNumber = response[0].invoiceNumber;
            this.data.InvoiceNumber = response[0].invoiceNumber;
            this.data.ChangeInvoiceNumber = "false";
            this.data.Id = response[0].invoiceId;

            this.IsSaveDone = true;
            this.isFormSubmit = false;
            this.GetInvoiceById();
            setTimeout(() => {
              this.UpdateInvoice(true);
            }, 500);
            // const Saved = this.translate.instant("ALERTMESSAGES.Saved");
            // this.toastr.success(Saved, "Success");
          } else {
            this.toastr.error(response[0].isDone, "error");
          }
          this.CopyAndCreateNewDisable = false;
          this.authorizeDisable = true;
          this.postDisable = true;

          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    } else {
      $("#BtnPCSave").prop("disabled", false);
      Helpers.setLoading(false);
      this.toastr.error("Please Fill All the Details", "error");
    }
  }

  // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  CopyAndCreateNew() {
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    this.CopyAndCreateNewDisable = true;
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      this.data.ActualCustomer = this.inv_pending_objData.Customer;
      this.data.CustomerId = this.inv_pending_objData.BillToParty;
      this.data.InvoiceNumber = null;
      this.data.InvoiceDate = this.data[this.InvoiceDate.dataField];
      this.data.InvoicePaymentTerms = this.data[this.CreditDays.dataField];
      this.data.InvoiceDueDate = this.data[this.InvoiceDueDate.dataField];
      this.data.SalesPerson = this.data[this.RefNo.dataField];
      this.data.PaymentTerm = this.data[this.TermsConditions.dataField];
      this.data.Remark = this.data[this.InvoiceRemark.dataField];
      this.data.PaymentReference = this.data[this.PaymentRef.dataField];
      this.data.InvoiceRefId = this.data.Id
      this.data.UserId = this.userId;
      this.data.Id = null;

      if (this.AdditionalMasterFlag == true) {
        this.data.BoschLegalEntityName = this.data[this.EntityName.dataField];
        this.data.BoschBusinessDivisionName = this.data[this.DivisionName.dataField];
        this.data.BoschServiceTypeName = this.data[this.ServiceType.dataField];
        this.data.BoschWarehouseName = this.data[this.WarehouseName.dataField];
        this.data.BoschUsername = this.data[this.BoschUsername.dataField];
      } else {
        this.data.BoschLegalEntityName = null;
        this.data.BoschBusinessDivisionName = null;
        this.data.BoschServiceTypeName = null;
        this.data.BoschWarehouseName = null;
        this.data.BoschUsername = null;
      }
      //end
      this.data.TotalAmount = this.fotData.NetTotalAmount;
      this.data.InvoiceDetails = [];
      let i = 0;
      this.GeneratedInvoiceList.forEach((element) => {
        this.data.InvoiceDetails[i] = {};
        this.data.InvoiceDetails[i] = element;
        this.data.InvoiceDetails[i].Rate = element.UnitRate;
        this.data.InvoiceDetails[i].ChargedGST = element.ChargedGST;
        this.data.InvoiceDetails[i].Id = "";
        i++;
      });
      this.data.ChangeInvoiceNumber = this.data.ChangeInvoiceNumber;
      this._appService.Post("Sales", "SaveInvoice_BySp", this.data).subscribe(
        (response) => {
          if (response[0].isDone == 'OK') {
            this.CustomerDetail.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.data.ProformaInvoiceNumber = response[0].ProformaInvoiceNumber;
            this.CustomerDetail.InvoiceNumber = response[0].invoiceNumber;
            this.data.InvoiceNumber = response[0].invoiceNumber;
            this.data.ChangeInvoiceNumber = "false";
            this.data.Id = response[0].invoiceId;

            this.IsSaveDone = true;
            this.isFormSubmit = false;
            this.GetInvoiceById();
            setTimeout(() => {
              this.UpdateInvoice(true);
            }, 500);

            // const Saved = this.translate.instant("ALERTMESSAGES.Saved");
            // this.toastr.success(Saved, "Success");
          } else {
            this.toastr.error(response[0].isDone, "error");
          }
          this.CopyAndCreateNewDisable = false;
          this.authorizeDisable = true;
          this.postDisable = true;

          Helpers.setLoading(false);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    } else {
      $("#BtnPCSave").prop("disabled", false);
      Helpers.setLoading(false);
      this.toastr.error("Please Fill All the Details", "error");
    }
  }

  // Added by priya - 05/03/2026 - cn(PRIYA-MAR26-001)
  GetInvoiceType() {
    this._appService.GetById("Charge", "GetChargeType", this.TenantId).subscribe(
      (response) => {
        this.InvoiceTypeList = response;
      },
      (err) => {
        this.toastr.error("Error occurred while fetching Charge Type !", "error");
      }
    );
  }

  // Added by priya - 09/05/2026 - cn(PRIYA-MAY26-002)
  ViewExpenses() {
    if(!this.AddInvoice.LRNo){
      this.toastr.warning('Please select LR no');
      return;
    }
    this.modalRef = this.modalService.open(this.ExpenseNBills, { windowClass: 'BillExpenseModal' });
    setTimeout(() => {
      this.GetExpenseByTripId();
      this.GetBillsByTripId();
    }, 300);
  }

  // Added by priya - 09/05/2026 - cn(PRIYA-MAY26-002)
  GetExpenseByTripId() {
    this._appService.GetByOneParam("Sales", "GetExpensebytrip", this.AddInvoice.ConsignmentNoteDetailId).subscribe(
      (response) => {
        this.ExpenseTable.data = response;
        // this.ExpenseTable.footerData[0].Amount = 0;
        // this.ExpenseTable.data.forEach(element => {
        //   this.ExpenseTable.footerData[0].Amount += element.Amount;
        // })
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }

  // Added by priya - 09/05/2026 - cn(PRIYA-MAY26-002)
  GetBillsByTripId() {
    this._appService.GetByOneParam("Sales", "GetBilsByTrip", this.AddInvoice.ConsignmentNoteDetailId).subscribe(
      (response) => {
        this.BillsTable.data = response;
        // this.BillsTable.footerData[0].Amount = 0;
        // this.BillsTable.data.forEach(element => {
        //   this.BillsTable.footerData[0].Amount += element.Amount;
        // })
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }

}
